import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { faPlus, faMinus, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt, faTimesCircle, faCalendarAlt, faCheckCircle } from '@fortawesome/free-regular-svg-icons';

import { BasicInformationsService } from 'src/app/shared/services/basic-informations.service';
import { BasicInformations } from 'src/app/shared/models/basic-informations.model';
import { Subscription, } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { SendingSumAndPremiumInfoService } from 'src/app/shared/services/sending-sum-and-premium-info.service';
import { InsuranceSumAndPremium } from 'src/app/shared/models/insurance-sum-and-premium.model';
import { BankService } from 'src/app/shared/services/admin-services/bank.service';
import { Filter } from 'src/app/shared/models/filter.model';
import { StandardOS } from '../../shared/models/calculator-models/standard-os.model';
import { CalculatorService } from 'src/app/shared/services/calculator-services/calculator-standard-os.service';
import { ExportCalculatorService } from 'src/app/shared/services/calculator-services/calculator-export.service';
import { SaveDraftService } from 'src/app/shared/services/save-draft.service';
import { DigitalService } from 'src/app/shared/services/digital.service';
import { ProductRoleService } from 'src/app/shared/services/admin-services/product-role.service';
import { StandardOSExport } from 'src/app/shared/models/export-models/standard-os-export.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StandardOSOffer } from 'src/app/shared/models/offer-models/standard-os-offer.model';
import { OfferClient } from 'src/app/shared/models/offer-models/offer-client.model';
import { HealthQuestionnaire } from 'src/app/shared/models/offer-models/health-questionnaire.model';
import { FATCAQuestionnaire } from 'src/app/shared/models/offer-models/fatca-questionnaire.model';
import { SPNFTQuestionnaire } from 'src/app/shared/models/offer-models/spnft-questionnaire.model';
import { PLATIMATICQuestionnaire } from 'src/app/shared/models/offer-models/platimatik-questionnaire.model';
import { Beneficiaries } from 'src/app/shared/models/offer-models/beneficiaries.model';
import { OfferService } from 'src/app/shared/services/offer-services/offer.service';
import { OfferInsuree } from 'src/app/shared/models/offer-models/offer-insuree.model';
import { OccupationService } from 'src/app/shared/services/admin-services/occupation.service';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { Router } from '@angular/router';
import { EditOfferService } from 'src/app/shared/services/edit-offer.service';
import { RoleSendService } from 'src/app/shared/services/role-send.service';
import { RiskAssessment } from 'src/app/shared/models/offer-models/risk-assessment.model';
import { RedemptionAndCapitalizations } from 'src/app/shared/models/offer-models/redemption-capitalization-model';
import { RemoveInfoService } from 'src/app/shared/services/remove-info.service';
import { FillDraftOfferService } from 'src/app/shared/services/fill-draft.service';
import { SendInfoService } from 'src/app/shared/services/send-info.service';

@Component({
  selector: 'app-standard-calculation-insured-sum',
  templateUrl: './standard-calculation-insured-sum.component.html',
  styleUrls: ['./standard-calculation-insured-sum.component.sass']
})
export class StandardCalculationInsuredSumComponent implements OnInit, OnDestroy {
  @ViewChild('insuredBlock', { static: false }) private insuredBlock: ElementRef;
  @ViewChild('usersBlock', { static: false }) private usersBlock: ElementRef;
  @ViewChild('healthBlock', { static: false }) private healthBlock: ElementRef;
  @ViewChild('fatcaBlock', { static: false }) private fatcaBlock: ElementRef;
  @ViewChild('spnftBlock', { static: false }) private spnftBlock: ElementRef;
  @ViewChild('platimatikBlock', { static: false }) private platimatikBlock: ElementRef;

  faPlus = faPlus;
  faMinus = faMinus;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faTrashAlt = faTrashAlt;
  faTimesCircle = faTimesCircle;
  faCalendarAlt = faCalendarAlt;
  faCheckCircle = faCheckCircle;
  @ViewChild('alertModal', { static: false }) private alertModal;
  @ViewChild('emailModal', { static: false }) private emailModal;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild('accNumber', { static: false }) private accNumber;
  @ViewChild('riskFormModal', { static: false }) private riskFormModal;

  errorTitle: String;
  successTitle: String;

  infoBasics: BasicInformations;
  standardTableArray: Array<any>;
  standardPlusTableArray: Array<any>;
  standardProTableArray: Array<any>;

  basicInfoSubscription: Subscription;
  sumAndPremiumInfoSubscription: Subscription;

  insuredSumANdPremimBool: Boolean = true;
  basicInsuranceBool: Boolean = true;
  calculcatorUsersBool: Boolean = false;
  supplementaryInsuranceBool: Boolean = true;
  supplementaryIsnuranceHideAllBool: Boolean = false;
  healthQuestionnaireBool: Boolean = false;
  noticePersonalityBool: Boolean = false;
  noticeFatcaBool: Boolean = false;
  fatcaTypeBool: Boolean = null;
  formSpnftBool: Boolean = false;
  formPlatimatikBool: Boolean = false;
  hideExport: Boolean = false;

  // Forma za Osigurana suma i primija
  insuredSumAndPremiumForm = new FormGroup({
    insuranceStart: new FormControl({ value: '', disabled: true }),
    insuranceEnd: new FormControl({ value: '', disabled: true }),
    insurancePeriod: new FormControl('', []),
    accessAge: new FormControl('', [Validators.required]),
    gender: new FormControl('', [Validators.required]),
    occupation: new FormControl('', [Validators.required]),
    dynamicsOfPayment: new FormControl('', [Validators.required]),
    cigarettesDaily: new FormControl('0', [Validators.required]),
    height: new FormControl('', [Validators.required]),
    weight: new FormControl('', [Validators.required]),
    currencyPayment: new FormControl('0', [Validators.required]),
    currencyPayout: new FormControl('0', [Validators.required]),
    indexation: new FormControl('', [Validators.required]),
    methodPayment: new FormControl('', [Validators.required])
  })

  // Lista korisnika
  insuranceUsers: Array<Beneficiaries> = [];
  // Forma za korisnike
  insuranceUserForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    role: new FormControl('', [Validators.required])
  })

  // Forma za Osnovno osiguranje
  basicInfoForm = new FormGroup({
    premiumRate: new FormControl('', []),
    standardRate: new FormControl({ value: '', disabled: true }),
    standardPlusRate: new FormControl({ value: '', disabled: true }),
    standardProRate: new FormControl({ value: '', disabled: true }),
    noSupplementaryInsurance: new FormControl(false, [])
  })

  // Forma za Zdravstveni upitnik
  healthForm = new FormGroup({
    threeMonthStayAbroad: new FormControl('', [Validators.required]),
    threeMonthStayAbroadDescription: new FormControl('', [Validators.required]),
    deniedAcceptedRequest: new FormControl('', [Validators.required]),
    deniedacceptedRequestDescription: new FormControl('', [Validators.required]),
    sportActivity: new FormControl('', [Validators.required]),
    sportActivityDescription: new FormControl('', [Validators.required]),
    constantDoctorTreats: new FormControl('', [Validators.required]),
    constantDoctorTreatsDescription: new FormControl('', [Validators.required]),
    specialMedicalExamination: new FormControl('', [Validators.required]),
    specialMedicalExaminationDescription: new FormControl('', [Validators.required]),
    takingMedicines: new FormControl('', [Validators.required]),
    takingMedicinesDescription: new FormControl('', [Validators.required]),
    alcoholOrIntoxicants: new FormControl('', [Validators.required]),
    alcoholOrIntoxicantsDescription: new FormControl('', [Validators.required]),
    helpForAlcoholAddiction: new FormControl('', [Validators.required]),
    helpForAlcoholAddictionDescription: new FormControl('', [Validators.required]),
    consumeCigarettes: new FormControl('', [Validators.required]),
    consumeCigarettesDescription: new FormControl('', [Validators.required]),
    seriousIllness: new FormControl('', [Validators.required]),
    seriousIllnessDescription: new FormControl('', [Validators.required]),
    dangerAtWork: new FormControl('', [Validators.required]),
    dangerAtWorkDescription: new FormControl('', [Validators.required]),
    tenYearMedicalTests: new FormControl('', [Validators.required]),
    tenYearmedicalTestsDescription: new FormControl('', [Validators.required]),
    thirtyDaysIncapable: new FormControl('', [Validators.required]),
    thirtyDaysIncapableDescription: new FormControl('', [Validators.required]),
    levelOfInvaliditet: new FormControl('', [Validators.required]),
    levelOfInvaliditetDescription: new FormControl('', [Validators.required]),
    newFifteenthQuestion: new FormControl('', [Validators.required]),
    newFifteenthQuestionDescription: new FormControl('', [Validators.required]),
    nameOfDoctor: new FormControl('', [Validators.required]),
    familySickness: new FormControl('', [Validators.required]),
    familySicknessDescription: new FormControl('', [Validators.required]),
    agreeToHealthQuestionnaire: new FormControl(true, [Validators.required])
  })

  // Forma za Obavestenje FATCA
  fatcaForm = new FormGroup({
    citizenshipSad: new FormControl('1', [Validators.required]),
    texpayerSad: new FormControl('1', [Validators.required]),
    insuredLegalEntitySad: new FormControl('1', [Validators.required]),
    insuredTaxpayerSad: new FormControl('1', [Validators.required]),
    insuredTenPrecentShare: new FormControl('1', [Validators.required]),
    insuredFinancialInstitution: new FormControl('1', [Validators.required])
  })

  // Forma za Obrazac SPNFT
  spnftForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    companyName: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    legalRepresentativeFirstname: new FormControl('', []),
    legalRepresentativeLastname: new FormControl('', []),
    representativeJmbg: new FormControl('', []),
    dob: new FormControl({ value: '', disabled: true }),
    settlementob: new FormControl('', [Validators.required]),
    pib: new FormControl('', []),
    mb: new FormControl('', []),
    address: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    numberOfDocument: new FormControl('', [Validators.required]),
    typeOfDocument: new FormControl('', [Validators.required]),
    // dateOfIssuringDocument: new FormControl('', [Validators.required]),
    dateOfIssuringDocument: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    personalDocumentExpirationDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    placeOfIssuringDocument: new FormControl('', [Validators.required]),
    citizenship: new FormControl('', [Validators.required]),
    officialCloseFamily: new FormControl('0', []),
    closeFamilyName: new FormControl('', []),
    officialPeriod: new FormControl('', []),
    cutomerAnotherPerson: new FormControl('0', [Validators.required]),
    cutomerAnotherPersonRole: new FormControl('', [Validators.required]),
    firstnameOnBehalf: new FormControl('', [Validators.required]),
    lastnameOnBehalf: new FormControl('', [Validators.required]),
    dobOnBehalf: new FormControl({ value: '', disabled: true }),
    settlementobOnBehalf: new FormControl('', [Validators.required]),
    jmbgOnBehalf: new FormControl('', [Validators.required]),
    addressOnBehalf: new FormControl('', [Validators.required]),
    postalCodeOnBehalf: new FormControl('', [Validators.required]),
    settlementOnBehalf: new FormControl('', [Validators.required]),
    idNumberOnBehalf: new FormControl('', [Validators.required]),
    idTypeOnBehalf: new FormControl('', [Validators.required]),
    idDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    idPlace: new FormControl('', [Validators.required]),
    purposeOfBusinessRelation: new FormControl('', [Validators.required]),
    purposeOfBusinessRelationOther: new FormControl('', [Validators.required]),
    originOfProperty: new FormControl('', [Validators.required]),
    originOfPropertyOther: new FormControl('', [Validators.required])
  })

  // Forma za Obrazac PLATIMATIK
  platimatikForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    placeOfResidence: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    firstThreeAccountNumber: new FormControl('', [Validators.required]),
    middleAccountNumber: new FormControl('', [Validators.required]),
    lastTwoAccountNumber: new FormControl('', [Validators.required]),
    bankName: new FormControl('', [Validators.required]),
    bankBic: new FormControl('', [Validators.required]),
    validityFirstTermFrom: new FormControl({ value: '', disabled: true }),
    validityFirstTermTo: new FormControl({ value: '', disabled: true }),
    validitySecondTermFrom: new FormControl({ value: '', disabled: true }),
    validitySecondTermTo: new FormControl({ value: '', disabled: true })
    // dateOfFirstObligationsDue: new FormControl('', []),
    // dateOfLastCommitment: new FormControl('', [])
  })

  // Forma za Dopunsko osiguranje
  insuranceCoverageForm = new FormGroup({
    deathByAccident: new FormControl({ value: '', disabled: true }),
    disabilityByAccident: new FormControl({ value: '', disabled: true }),
    surgery: new FormControl({ value: '', disabled: true }),
    monthlyRent: new FormControl({ value: '', disabled: true }),
    dailyFee: new FormControl({ value: '', disabled: true }),
    incidentRadio: new FormControl('3', [Validators.required]),
    premiumRateSupplementaryFirst: new FormControl({ value: '', disabled: true }),
    premiumRateSupplementarySecound: new FormControl({ value: '', disabled: true }),
    premiumRateSupplementaryThird: new FormControl({ value: '', disabled: true }),
    premiumRateSupplementaryForth: new FormControl({ value: '', disabled: true }),
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumPremiumRateSecound: new FormControl({ value: '', disabled: true }),
    sumPremiumRateThird: new FormControl({ value: '', disabled: true }),
    sumPremiumRateForth: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
    sumYearlySecound: new FormControl({ value: '', disabled: true }),
    sumYearlyThird: new FormControl({ value: '', disabled: true }),
    sumYearlyForth: new FormControl({ value: '', disabled: true }),
    planRadio: new FormControl('3', {}),
    bidCheck: new FormControl('', []),
    ransomCheck: new FormControl('', []),
    forewordCheck: new FormControl('', []),
    insuranceConditionsCheck: new FormControl('', [])
  })

  // Forma za Personalizovano ponuda dopunskog osiguranja
  personalForm = new FormGroup({
    deathByAccident: new FormControl('', []),
    invalidityByAccident: new FormControl('', []),
    monthlyRent: new FormControl({ value: '', disabled: true }),
    daylyFee: new FormControl({ value: '', disabled: true }),
    treatmanExpenses: new FormControl({ value: '', disabled: true }),
    includeMSO: new FormControl({ value: '0', disabled: true }),
    includeDNA: new FormControl({ value: '0', disabled: true }),
    additionalInsurance: new FormControl({ value: '', disabled: true }),

    riderDeath: new FormControl(''),
    tbType: new FormControl(''),
    riderTB: new FormControl(''),

    surgery: new FormControl({ value: '', disabled: true }),
    planRadio: new FormControl('3', []),
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumPremiumRateSecond: new FormControl({ value: '', disabled: true }),
    sumPremiumRateThird: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
    sumYearlySecond: new FormControl({ value: '', disabled: true }),
    sumYearlyThird: new FormControl({ value: '', disabled: true })
  })

  // Forma kada nema dopunskog osiguranja
  noCovrageForm = new FormGroup({
    planRadio: new FormControl('3', []),
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumPremiumRateSecond: new FormControl({ value: '', disabled: true }),
    sumPremiumRateThird: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
    sumYearlySecond: new FormControl({ value: '', disabled: true }),
    sumYearlyThird: new FormControl({ value: '', disabled: true })
  })

  // Forma za cekboksove na dnu
  checkBoxesForm = new FormGroup({
    confirmVeracity: new FormControl(false, []),
    confirmData: new FormControl(false, []),
    confirmSMS: new FormControl('1', []),
    confirmEmail: new FormControl('1', []),
    offer: new FormControl(true, []),
    redemptionAndCapitalization: new FormControl(false, []),
    proContract: new FormControl(false, []),
    terms: new FormControl(false, []),
    doctor: new FormControl(false, [])
  })

  riskAssessmentForm = new FormGroup({
    question1: new FormControl('', [Validators.required]),
    question2: new FormControl('', [Validators.required]),
    question3: new FormControl('', [Validators.required]),
    question4: new FormControl('', [Validators.required]),
    question5: new FormControl('', [Validators.required]),
    question6: new FormControl('', [Validators.required]),
    question7: new FormControl('', [Validators.required]),
    question8: new FormControl('', [Validators.required]),
    question9: new FormControl('', [Validators.required]),
    question10: new FormControl('', [Validators.required]),
    question11: new FormControl('', [Validators.required]),
    question12: new FormControl('', [Validators.required]),
    question13: new FormControl('', [Validators.required]),
    question14: new FormControl('', [Validators.required]),
    question15: new FormControl('', [Validators.required]),
    question16: new FormControl('', [Validators.required]),
    question17: new FormControl('', [Validators.required]),
    question18: new FormControl('', [Validators.required]),
    question19: new FormControl('', [Validators.required]),
    question20: new FormControl('', [Validators.required]),
    question21: new FormControl('', [Validators.required]),
    question22: new FormControl('', [Validators.required]),
    question23: new FormControl('', [Validators.required]),
    question24: new FormControl('', [Validators.required]),
    question25: new FormControl('', [Validators.required]),
    question26: new FormControl('', [Validators.required]),
    question27: new FormControl('', [Validators.required]),
    question28: new FormControl('', [Validators.required]),
    question29: new FormControl('', [Validators.required]),
    unableToGetData: new FormControl('')
  })


  basicInfo: BasicInformations;
  editSubscription: Subscription;
  roleService: Subscription;

  roleType: String = '';
  draftBool: Boolean = true;
  updateDraftModelFull: StandardOSOffer;
  offerId: Number;

  constructor(private basicInformationsService: BasicInformationsService, private sendingSumAndPremiumInfo: SendingSumAndPremiumInfoService, private bankService: BankService, private calculatorService: CalculatorService, private saveDraftService: SaveDraftService, private digitalService: DigitalService, private productRoleService: ProductRoleService, private exportCalculatorService: ExportCalculatorService, private modalService: NgbModal, private offerService: OfferService, private occupationService: OccupationService, private userService: UserService, private router: Router, private editOfferService: EditOfferService, private roleSendService: RoleSendService, private removeInfoService: RemoveInfoService, private fillDraftOfferService: FillDraftOfferService, private sendInfoService: SendInfoService) {


    // console.log(this.todayDate.getMonth())

    if (this.todayDate.getDate() > 25) {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 2);
    } else {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    }

    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));


    this.getOccupation();
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
    this.editSubscription = this.editOfferService.info$.subscribe(
      (res: Number) => {
        // console.log(res)
        if (res == 0) {

        } else {
          this.draftBool = false;
          this.updateDraftModelFull = new StandardOSOffer({ Contractor: new OfferClient(), Insuree: new OfferInsuree(), HealthQuestionnaire: new HealthQuestionnaire(), FATCAQuestionnaire: new FATCAQuestionnaire(), SPNFTForm: new SPNFTQuestionnaire(), PlatimatikForm: new PLATIMATICQuestionnaire(), RedemptionAndCapitalization: new RedemptionAndCapitalizations() })
          this.offerService.getOne(res)
            .then(
              (x: any) => {
                console.log(x);
                this.offerId = x.id;
                this.editOfferService.sendOfferID(0)
                this.updateDraftModelFull.data.AppointmentID = x.appointmentID;
                this.updateDraftModelFull.data.Contractor.ID = x.contractor.id;
                this.updateDraftModelFull.data.ContractorID = x.contractor.id;
                this.updateDraftModelFull.data.Insuree.ID = x.insuree.id;
                this.updateDraftModelFull.data.InsureeID = x.insuree.id;
                this.updateDraftModelFull.data.ID = x.id
                this.updateDraftModelFull.data.RedemptionAndCapitalization.OfferID = x.id
                this.updateDraftModelFull.data.HealthQuestionnaire.OfferID = x.id
                this.updateDraftModelFull.data.FATCAQuestionnaire.OfferID = x.id
                this.updateDraftModelFull.data.SPNFTForm.OfferID = x.id
                this.updateDraftModelFull.data.PlatimatikForm.OfferID = x.id
                this.personalForm.get('planRadio').setValue(x.productType == 0 ? '1' : x.productType == 1 ? '2' : x.productType == 2 ? '3' : '2')
                this.insuranceCoverageForm.get('planRadio').setValue(x.productType == 0 ? '1' : x.productType == 1 ? '2' : x.productType == 2 ? '3' : '2')
                this.noCovrageForm.get('planRadio').setValue(x.productType == 0 ? '1' : x.productType == 1 ? '2' : x.productType == 2 ? '3' : '2')

                this.getRoles(x.productType);

                if (x.additionalPremiumRate == 0 || x.additionalPremiumRate == null) {
                  this.basicInfoForm.get('noSupplementaryInsurance').setValue(true)
                  this.supplementaryIsnuranceHideAllBool = true;
                }

                if (x.additionalInsuranceType == 0) {
                  this.supplementaryInsuranceBool = false
                  this.supplementaryIsnuranceHideAllBool = false
                  this.personalForm.get('deathByAccident').setValue(x.deathByAccident ? x.deathByAccident : '')
                  this.personalForm.get('invalidityByAccident').setValue(x.invalidityByAccident ? x.invalidityByAccident : '')
                  this.personalForm.get('surgery').setValue(x.surgery ? x.surgery : '')
                  this.personalForm.get('treatmanExpenses').setValue(x.treatmentExpenses ? x.treatmentExpenses : '')
                  this.personalForm.get('daylyFee').setValue(x.dailyFee ? x.dailyFee : '')
                  this.personalForm.get('monthlyRent').setValue(x.monthlyRent ? x.monthlyRent : '')
                  this.personalForm.get('includeDNA').setValue(x.includeDNA ? '1' : '0')
                  this.personalForm.get('includeMSO').setValue(x.includeMSO ? '1' : '0')

                  this.personalForm.get('riderDeath').setValue(x.additionalRiderDeath ? x.additionalRiderDeath : '')
                  this.personalForm.get('tbType').setValue(x.additionalRiderTBType ? x.additionalRiderTBType.toString() : '')
                  this.personalForm.get('riderTB').setValue(x.additionalRiderTB ? x.additionalRiderTB : '')
                  this.disabledPersonal();
                } else if (x.additionalInsuranceType == 5) {

                } else {
                  this.insuranceCoverageForm.get('incidentRadio').setValue(x.additionalInsuranceType.toString())
                }

                this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(x.insuranceStart, 'dd.MM.yyyy', 'en'))
                this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(x.insuranceEnd, 'dd.MM.yyyy', 'en'))
                this.insuredSumAndPremiumForm.get('insurancePeriod').setValue(x.duration)
                this.insuredSumAndPremiumForm.get('accessAge').setValue(x.startingAge)
                this.insuredSumAndPremiumForm.get('gender').setValue(x.gender)
                this.insuredSumAndPremiumForm.get('dynamicsOfPayment').setValue(x.paymentFrequency)
                this.insuredSumAndPremiumForm.get('cigarettesDaily').setValue(x.cigarettesPerDay)
                this.insuredSumAndPremiumForm.get('height').setValue(x.height)
                this.insuredSumAndPremiumForm.get('weight').setValue(x.weight)
                this.insuredSumAndPremiumForm.get('currencyPayment').setValue(x.paymentInCurrency || x.paymentInCurrency == 0 ? x.paymentInCurrency.toString() : '')
                this.insuredSumAndPremiumForm.get('currencyPayout').setValue(x.paymentOutCurrency || x.paymentOutCurrency == 0 ? x.paymentOutCurrency.toString() : '')
                this.insuredSumAndPremiumForm.get('indexation').setValue(x.indexation == true ? '1' : x.indexation == false ? '0' : '')
                this.insuredSumAndPremiumForm.get('methodPayment').setValue(x.paymentType || x.paymentType == 0 ? x.paymentType.toString() : '')
                this.changeDate(null)
                this.basicInfoForm.get('premiumRate').setValue(x.premiumRate)
                // occupationService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
                //   .subscribe(
                //     (p: { hazardLevel: Number, id: Number, name: String }[]) => {
                //       for (let i = 0; i < p.length; i++) {
                //         // console.log(p[i])
                //         if (x.occupationID == p[i].id) {
                //           // console.log(p[i].hazardLevel + '-' + x.occupationID)
                //           this.insuredSumAndPremiumForm.get('occupation').setValue(p[i].hazardLevel + '-' + x.occupationID)
                //         }
                //       }
                //       this.sendInformations();
                //     }
                //   )

                this.fillDraftOfferService.sendDraft({ contractor: x.contractor, insuree: x.insuree, contractorIsInsuree: x.contractorIsInsuree })

                this.insuranceUsers = [];
                if (x.beneficiaries.length > 0) {
                  for (let i = 0; i < x.beneficiaries.length; i++) {
                    let ob = {
                      OfferID: x.id,
                      Name: x.beneficiaries[i].name,
                      JMBG: x.beneficiaries[i].jmbg,
                      Description: x.beneficiaries[i].description,
                      RoleID: x.beneficiaries[i].roleID,
                      RoleName: x.beneficiaries[i].role.name
                    }
                    this.insuranceUsers.push(ob);
                  }
                }

                if (x.healthQuestionnaire) {
                  this.healthForm.get('threeMonthStayAbroad').setValue(x.healthQuestionnaire.q1Answer == null ? '' : x.healthQuestionnaire.q1Answer ? '0' : '1')
                  this.healthForm.get('threeMonthStayAbroadDescription').setValue(x.healthQuestionnaire.q1Description ? x.healthQuestionnaire.q1Description : '')
                  this.healthForm.get('deniedAcceptedRequest').setValue(x.healthQuestionnaire.q2Answer == null ? '' : x.healthQuestionnaire.q2Answer ? '0' : '1')
                  this.healthForm.get('deniedacceptedRequestDescription').setValue(x.healthQuestionnaire.q2Description ? x.healthQuestionnaire.q2Description : '')
                  this.healthForm.get('sportActivity').setValue(x.healthQuestionnaire.q3Answer == null ? '' : x.healthQuestionnaire.q3Answer ? '0' : '1')
                  this.healthForm.get('sportActivityDescription').setValue(x.healthQuestionnaire.q3Description ? x.healthQuestionnaire.q3Description : '')
                  this.healthForm.get('constantDoctorTreats').setValue(x.healthQuestionnaire.q4Answer == null ? '' : x.healthQuestionnaire.q4Answer ? '0' : '1')
                  this.healthForm.get('constantDoctorTreatsDescription').setValue(x.healthQuestionnaire.q4Description ? x.healthQuestionnaire.q4Description : '')
                  this.healthForm.get('specialMedicalExamination').setValue(x.healthQuestionnaire.q5Answer == null ? '' : x.healthQuestionnaire.q5Answer ? '0' : '1')
                  this.healthForm.get('specialMedicalExaminationDescription').setValue(x.healthQuestionnaire.q5Description ? x.healthQuestionnaire.q5Description : '')
                  this.healthForm.get('takingMedicines').setValue(x.healthQuestionnaire.q6Answer == null ? '' : x.healthQuestionnaire.q6Answer ? '0' : '1')
                  this.healthForm.get('takingMedicinesDescription').setValue(x.healthQuestionnaire.q6Description ? x.healthQuestionnaire.q6Description : '')
                  this.healthForm.get('alcoholOrIntoxicants').setValue(x.healthQuestionnaire.q7Answer == null ? '' : x.healthQuestionnaire.q7Answer ? '0' : '1')
                  this.healthForm.get('alcoholOrIntoxicantsDescription').setValue(x.healthQuestionnaire.q7Description ? x.healthQuestionnaire.q7Description : '')
                  this.healthForm.get('helpForAlcoholAddiction').setValue(x.healthQuestionnaire.q8Answer == null ? '' : x.healthQuestionnaire.q8Answer ? '0' : '1')
                  this.healthForm.get('helpForAlcoholAddictionDescription').setValue(x.healthQuestionnaire.q8Description ? x.healthQuestionnaire.q8Description : '')
                  this.healthForm.get('consumeCigarettes').setValue(x.healthQuestionnaire.q9Answer == null ? '' : x.healthQuestionnaire.q9Answer ? '0' : '1')
                  this.healthForm.get('consumeCigarettesDescription').setValue(x.healthQuestionnaire.q9Description ? x.healthQuestionnaire.q9Description : '')
                  this.healthForm.get('seriousIllness').setValue(x.healthQuestionnaire.q10Answer == null ? '' : x.healthQuestionnaire.q10Answer ? '0' : '1')
                  this.healthForm.get('seriousIllnessDescription').setValue(x.healthQuestionnaire.q10Description ? x.healthQuestionnaire.q10Description : '')
                  this.healthForm.get('dangerAtWork').setValue(x.healthQuestionnaire.q11Answer == null ? '' : x.healthQuestionnaire.q11Answer ? '0' : '1')
                  this.healthForm.get('dangerAtWorkDescription').setValue(x.healthQuestionnaire.q11Description ? x.healthQuestionnaire.q11Description : '')
                  this.healthForm.get('tenYearMedicalTests').setValue(x.healthQuestionnaire.q12Answer == null ? '' : x.healthQuestionnaire.q12Answer ? '0' : '1')
                  this.healthForm.get('tenYearmedicalTestsDescription').setValue(x.healthQuestionnaire.q12Description ? x.healthQuestionnaire.q12Description : '')
                  this.healthForm.get('thirtyDaysIncapable').setValue(x.healthQuestionnaire.q13Answer == null ? '' : x.healthQuestionnaire.q13Answer ? '0' : '1')
                  this.healthForm.get('thirtyDaysIncapableDescription').setValue(x.healthQuestionnaire.q13Description ? x.healthQuestionnaire.q13Description : '')
                  this.healthForm.get('levelOfInvaliditet').setValue(x.healthQuestionnaire.q14Answer == null ? '' : x.healthQuestionnaire.q14Answer ? '0' : '1')
                  this.healthForm.get('levelOfInvaliditetDescription').setValue(x.healthQuestionnaire.q14Description ? x.healthQuestionnaire.q14Description : '')

                  this.healthForm.get('newFifteenthQuestion').setValue(x.healthQuestionnaire.q15Answer == null ? '' : x.healthQuestionnaire.q15Answer ? '0' : '1')
                  this.healthForm.get('newFifteenthQuestionDescription').setValue(x.healthQuestionnaire.q15Description ? x.healthQuestionnaire.q15Description : '')

                  this.healthForm.get('nameOfDoctor').setValue(x.healthQuestionnaire.q16Answer ? x.healthQuestionnaire.q16Answer : '')
                  this.healthForm.get('familySickness').setValue(x.healthQuestionnaire.q17Answer == null ? '' : x.healthQuestionnaire.q17Answer ? '0' : '1')
                  this.healthForm.get('familySicknessDescription').setValue(x.healthQuestionnaire.q17Description ? x.healthQuestionnaire.q17Description : '')
                  this.healthForm.get('agreeToHealthQuestionnaire').setValue(x.healthQuestionnaire.agreement)
                }

                if (x.fatcaQuestionnaire) {
                  this.fatcaForm.get('citizenshipSad').setValue(x.fatcaQuestionnaire.q1NP ? '0' : '1')
                  this.fatcaForm.get('texpayerSad').setValue(x.fatcaQuestionnaire.q2NP ? '0' : '1')
                  this.fatcaForm.get('insuredLegalEntitySad').setValue(x.fatcaQuestionnaire.q1LE ? '0' : '1')
                  this.fatcaForm.get('insuredTaxpayerSad').setValue(x.fatcaQuestionnaire.q2LE ? '0' : '1')
                  this.fatcaForm.get('insuredTenPrecentShare').setValue(x.fatcaQuestionnaire.q3LE ? '0' : '1')
                  this.fatcaForm.get('insuredFinancialInstitution').setValue(x.fatcaQuestionnaire.q4LE ? '0' : '1')
                }

                if (x.spnftForm) {
                  this.spnftForm.get('firstname').setValue(x.spnftForm.firstname)
                  this.spnftForm.get('lastname').setValue(x.spnftForm.lastname)
                  this.spnftForm.get('companyName').setValue(x.spnftForm.companyName)
                  this.spnftForm.get('jmbg').setValue(x.spnftForm.jmbg)
                  // this.spnftForm.get('jmbg').setValue(x.spnftForm.jmbg)
                  if (x.spnftForm.jmbg) {
                    this.setSPNFTDate()
                  }
                  this.spnftForm.get('settlementob').setValue(x.spnftForm.placeOfBirth)
                  this.spnftForm.get('address').setValue(x.spnftForm.address)
                  this.spnftForm.get('postalCode').setValue(x.spnftForm.postalCode)
                  this.spnftForm.get('settlement').setValue(x.spnftForm.settlement)
                  this.spnftForm.get('citizenship').setValue(x.spnftForm.citizenship)
                  this.spnftForm.get('legalRepresentativeFirstname').setValue(x.spnftForm.legalRepresentativeFirtsname ? x.spnftForm.legalRepresentativeFirtsname : '')
                  this.spnftForm.get('legalRepresentativeLastname').setValue(x.spnftForm.legalRepresentativeLastname ? x.spnftForm.legalRepresentativeLastname : '')
                  this.spnftForm.get('representativeJmbg').setValue(x.spnftForm.legalRepresentativeJMBG ? x.spnftForm.legalRepresentativeJMBG : '')
                  this.spnftForm.get('pib').setValue(x.spnftForm.taxID ? x.spnftForm.taxID : '')
                  this.spnftForm.get('mb').setValue(x.spnftForm.companyID ? x.spnftForm.companyID : '')
                  this.spnftForm.get('numberOfDocument').setValue(x.spnftForm.personalDocumentNumber ? x.spnftForm.personalDocumentNumber : '')
                  this.spnftForm.get('typeOfDocument').setValue(x.spnftForm.personalDocumentType || x.spnftForm.personalDocumentType == 0 ? x.spnftForm.personalDocumentType.toString() : '')
                  // if (x.spnftForm.personalDocumentIssuedDate)
                  // console.log(x.spnftForm.personalDocumentIssuedDate)
                  // console.log(x.spnftForm.personalDocumentIssuedDate ? x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('dateOfIssuringDocument').setValue(x.spnftForm.personalDocumentIssuedDate ? x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('personalDocumentExpirationDate').setValue(x.spnftForm.personalDocumentExpirationDate ? x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('placeOfIssuringDocument').setValue(x.spnftForm.personalDocumentIssuedPlace)

                  this.spnftForm.get('officialCloseFamily').setValue(x.spnftForm.isPoliticianOrCloseAssociate ? '1' : '0')
                  this.spnftForm.get('closeFamilyName').setValue(x.spnftForm.inOffice)
                  this.spnftForm.get('officialPeriod').setValue(x.spnftForm.remarkIfYes)

                  this.spnftForm.get('cutomerAnotherPerson').setValue(x.spnftForm.clientAppliesThroughIntermediary ? '1' : '0')
                  this.spnftForm.get('cutomerAnotherPersonRole').setValue(x.spnftForm.intermediaryType || x.spnftForm.intermediaryType == 0 ? x.spnftForm.intermediaryType.toString() : '')
                  this.spnftForm.get('firstnameOnBehalf').setValue(x.spnftForm.intermediaryFirstname)
                  this.spnftForm.get('lastnameOnBehalf').setValue(x.spnftForm.intermediaryLastname)
                  this.spnftForm.get('settlementobOnBehalf').setValue(x.spnftForm.intermediaryPlaceOfBirth)
                  this.spnftForm.get('jmbgOnBehalf').setValue(x.spnftForm.intermediaryJMBG)
                  // if (x.spnftForm.personalDocumentIssuedDate)
                  this.spnftForm.get('dobOnBehalf').setValue(x.spnftForm.intermediaryDateOfBirth ? formatDate(x.spnftForm.intermediaryDateOfBirth, 'dd.MM.yyyy', 'en') : '')
                  this.spnftForm.get('addressOnBehalf').setValue(x.spnftForm.intermediaryAddress)
                  this.spnftForm.get('postalCodeOnBehalf').setValue(x.spnftForm.intermediaryPostalCode)
                  this.spnftForm.get('settlementOnBehalf').setValue(x.spnftForm.intermediarySettlement)
                  this.spnftForm.get('idNumberOnBehalf').setValue(x.spnftForm.intermediaryPersonalDocumentNumber)
                  this.spnftForm.get('idTypeOnBehalf').setValue(x.spnftForm.intermediaryPersonalDocumentType || x.spnftForm.intermediaryPersonalDocumentType == 0 ? x.spnftForm.intermediaryPersonalDocumentType : '')
                  // if (x.spnftForm.intermediaryPersonalDocumentIssuedDate)
                  this.spnftForm.get('idDate').setValue(x.spnftForm.intermediaryPersonalDocumentIssuedDate ? formatDate(x.spnftForm.intermediaryPersonalDocumentIssuedDate, 'dd.MM.yyyy', 'en') : '')
                  this.spnftForm.get('idPlace').setValue(x.spnftForm.intermediaryPersonalDocumentIssuedPlace)
                  if (x.spnftForm.businessRelationshipClientPurpose)
                    this.spnftForm.get('purposeOfBusinessRelation').setValue(x.spnftForm.businessRelationshipClientPurpose || x.spnftForm.businessRelationshipClientPurpose == 0 ? x.spnftForm.businessRelationshipClientPurpose.toString() : '')
                  this.spnftForm.get('purposeOfBusinessRelationOther').setValue(x.spnftForm.businessRelationshipClientPurposeOther)
                  this.spnftForm.get('originOfProperty').setValue(x.spnftForm.propertyOrigin || x.spnftForm.propertyOrigin == 0 ? x.spnftForm.propertyOrigin.toString() : '')
                  this.spnftForm.get('originOfPropertyOther').setValue(x.spnftForm.propertyOriginOther)
                }

                if (x.platimatikForm) {
                  this.platimatikForm.get('firstname').setValue(x.platimatikForm.firstname)
                  this.platimatikForm.get('lastname').setValue(x.platimatikForm.lastname)
                  this.platimatikForm.get('address').setValue(x.platimatikForm.address)
                  this.platimatikForm.get('postalCode').setValue(x.platimatikForm.postalCode)
                  this.platimatikForm.get('placeOfResidence').setValue(x.platimatikForm.settlement)
                  this.platimatikForm.get('jmbg').setValue(x.platimatikForm.jmbg)
                  this.platimatikForm.get('firstThreeAccountNumber').setValue(x.platimatikForm.accountNumber.substring(0, 3))
                  this.platimatikForm.get('middleAccountNumber').setValue(x.platimatikForm.accountNumber.substring(3, 16))
                  this.platimatikForm.get('lastTwoAccountNumber').setValue(x.platimatikForm.accountNumber.substring(16, 18))
                  this.platimatikForm.get('bankName').setValue(x.platimatikForm.bank)
                  this.platimatikForm.get('bankBic').setValue(x.platimatikForm.bic)
                  this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
                  this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
                }

                this.checkBoxesForm.get('confirmVeracity').setValue(x.verified)
                this.checkBoxesForm.get('confirmData').setValue(x.verified2)
                this.checkBoxesForm.get('confirmSMS').setValue(x.notificationsAgreement ? '1' : '0')
                this.checkBoxesForm.get('confirmEmail').setValue(x.verified3 ? '1' : '0')

              }
            )
        }
      }
    )

    this.basicInfoSubscription = basicInformationsService.info$.subscribe(
      (res: BasicInformations) => {
        // console.log(res);
        this.basicInfo = res;
        if (res.data.contractorType == '1') {
          this.fatcaTypeBool = true;
          this.spnftForm.get('pib').setValue(res.data.contractorPIB);
          this.spnftForm.get('mb').setValue(res.data.contractorID);
          this.spnftForm.get('companyName').setValue(res.data.contractorResponsibleName);
        } else if (res.data.contractorType == '2') {
          this.fatcaTypeBool = false;
          this.spnftForm.get('pib').setValue('');
          this.spnftForm.get('mb').setValue('');
          this.spnftForm.get('companyName').setValue('');
        } else if (res.data.contractorType == '') {
          this.fatcaTypeBool = null;
        }

        // console.log(res.data)
        this.spnftForm.get('firstname').setValue(res.data.contractorFirstname);
        this.spnftForm.get('lastname').setValue(res.data.contractorLastname);
        this.spnftForm.get('jmbg').setValue(res.data.contractorJMBG);
        if (res.data.contractorJMBG) {
          if (res.data.contractorJMBG.length >= 7) {
            if (res.data.contractorJMBG.substring(4, 5) == '0') {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.2' + res.data.contractorJMBG.substring(4, 7))
            } else {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.1' + res.data.contractorJMBG.substring(4, 7))
            }
          }
        }
        if (res.data.insuredJMBG) {
          if (res.data.insuredJMBG.length >= 7) {
            if (res.data.insuredJMBG.substring(4, 5) == '0') {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            } else {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            }
          }
          // if (res.data.insuredJMBG.length >= 12) {
          //   if (parseInt(res.data.insuredJMBG.substring(9, 12)) < 500) {
          //     if (this.insuredSumAndPremiumForm.value.gender == 'Ž') {
          //       this.insuredSumAndPremiumForm.get('gender').setValue('M')
          //       this.hideExport = false
          //     }
          //   } else {
          //     if (this.insuredSumAndPremiumForm.value.gender == 'M') {
          //       this.insuredSumAndPremiumForm.get('gender').setValue('Ž')
          //       this.hideExport = false
          //     }
          //   }
          // }
        }
        this.spnftForm.get('address').setValue(res.data.contractorAddress);
        this.spnftForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.spnftForm.get('settlement').setValue(res.data.contractorSettlement);

        this.platimatikForm.get('firstname').setValue(res.data.contractorFirstname);
        this.platimatikForm.get('lastname').setValue(res.data.contractorLastname);
        this.platimatikForm.get('placeOfResidence').setValue(res.data.contractorSettlement);
        this.platimatikForm.get('address').setValue(res.data.contractorAddress);
        this.platimatikForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.platimatikForm.get('jmbg').setValue(res.data.contractorJMBG)


      }
    )
    this.sumAndPremiumInfoSubscription = sendingSumAndPremiumInfo.info$.subscribe(
      (res: InsuranceSumAndPremium) => {
        // console.log(res);
        if (res.data.insuranceStart)
          this.insuredSumAndPremiumForm.get('insuranceStart').setValue(res.data.insuranceStart);
        if (res.data.insurancePeriod) {
          this.insuredSumAndPremiumForm.get('insurancePeriod').setValue(res.data.insurancePeriod);
          let tempYear = this.todayDate.getFullYear();
          let tempMonth = this.todayDate.getMonth();
          let tempDay = this.todayDate.getDate();
          let tempDate = new Date(tempYear + this.insuredSumAndPremiumForm.value.insurancePeriod, tempMonth, tempDay);
          this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));
          this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
          this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
        }
        if (res.data.accessAge)
          this.insuredSumAndPremiumForm.get('accessAge').setValue(res.data.accessAge);
        if (res.data.gender)
          this.insuredSumAndPremiumForm.get('gender').setValue(res.data.gender);
        // if (res.data.occupation)
        //   this.insuredSumAndPremiumForm.get('occupation').setValue(res.data.occupation);
        if (res.data.dynamicsOfPayment)
          this.insuredSumAndPremiumForm.get('dynamicsOfPayment').setValue(res.data.dynamicsOfPayment);
        if (res.data.cigarettesDaily)
          this.insuredSumAndPremiumForm.get('cigarettesDaily').setValue(res.data.cigarettesDaily);
        if (res.data.height)
          this.insuredSumAndPremiumForm.get('height').setValue(res.data.height);
        if (res.data.weight)
          this.insuredSumAndPremiumForm.get('weight').setValue(res.data.weight);
        if (res.data.currencyPayment)
          this.insuredSumAndPremiumForm.get('currencyPayment').setValue(res.data.currencyPayment);
        if (res.data.currencyPayout)
          this.insuredSumAndPremiumForm.get('currencyPayout').setValue(res.data.currencyPayout);
        if (res.data.indexation)
          this.insuredSumAndPremiumForm.get('indexation').setValue(res.data.indexation);
        if (res.data.methodPayment)
          this.insuredSumAndPremiumForm.get('methodPayment').setValue(res.data.methodPayment)
      }
    )
  }

  ngOnInit() {
    // console.log(this.todayDate)
    this.getRoles(Number(this.insuranceCoverageForm.value.planRadio) - 1);
    this.getUser()
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'));
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
    this.editSubscription.unsubscribe();
    this.basicInfoSubscription.unsubscribe();
    this.sumAndPremiumInfoSubscription.unsubscribe();
  }


  todayDate = new Date();
  changeDate(change: Boolean) {
    if (change == true) {
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    } else if (change == false) {
      this.todayDate.setMonth(this.todayDate.getMonth() - 1);
    }
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'))

    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
    }

    if (this.insuredSumAndPremiumForm.value.insurancePeriod) {
      let tempYear = this.todayDate.getFullYear();
      let tempMonth = this.todayDate.getMonth();
      let tempDay = this.todayDate.getDate();
      let tempDate = new Date(tempYear + this.insuredSumAndPremiumForm.value.insurancePeriod, tempMonth, tempDay);
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));

      this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
      this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    }
  }
  endingDateSet() {
    if (this.insuredSumAndPremiumForm.value.insurancePeriod) {
      let tempYear = this.todayDate.getFullYear();
      let tempMonth = this.todayDate.getMonth();
      let tempDay = this.todayDate.getDate();
      let tempDate = new Date(tempYear + this.insuredSumAndPremiumForm.value.insurancePeriod, tempMonth, tempDay);
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));
      this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
      this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    } else {
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue('Trajanje osiguranja nije unet');
    }
    this.resetCalculation();
  }


  addInsuranceUser() {
    let num = 0;
    for (let i = 0; i < this.insuranceUsers.length; i++) {
      if (parseInt(this.insuranceUserForm.value.role.split('-')[0]) == this.insuranceUsers[i].RoleID) {
        num++;
      }
    }
    if (parseInt(this.insuranceUserForm.value.role.split('-')[2]) == 0) {
      if (num >= 1) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    } else {
      if (num >= parseInt(this.insuranceUserForm.value.role.split('-')[2])) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    }
    this.insuranceUserForm.reset();
  }
  removeFromList(i) {
    this.insuranceUsers.splice(i, 1);
  }

  disabledPersonal() {
    if (this.personalForm.value.invalidityByAccident) {
      this.personalForm.controls['surgery'].enable();
      this.personalForm.controls['monthlyRent'].enable();
      this.personalForm.controls['treatmanExpenses'].enable();
      this.personalForm.controls['daylyFee'].enable();
      this.personalForm.controls['includeDNA'].enable();
      this.personalForm.controls['includeMSO'].enable();
    } else {
      this.personalForm.controls['surgery'].disable();
      this.personalForm.controls['monthlyRent'].disable();
      this.personalForm.controls['treatmanExpenses'].disable();
      this.personalForm.controls['daylyFee'].disable();
      this.personalForm.controls['includeDNA'].disable();
      this.personalForm.controls['includeMSO'].disable();
    }
  }

  sentInformations: any;
  standardMessageDoctor: String;
  standardPlusMessageDoctor: String;
  standardProMessageDoctor: String;
  questionnarie: String = "Potrebno je popuniti finansijski upitnik.";
  hiv: String = "Potrebno je dostaviti rezultat testa na HIV."
  sendInformations() {
    if (this.insuredSumAndPremiumForm.value.insurancePeriod && this.insuredSumAndPremiumForm.value.accessAge && this.insuredSumAndPremiumForm.value.gender && this.insuredSumAndPremiumForm.value.dynamicsOfPayment && (this.insuredSumAndPremiumForm.value.cigarettesDaily || this.insuredSumAndPremiumForm.value.cigarettesDaily == 0) && this.insuredSumAndPremiumForm.value.height && this.insuredSumAndPremiumForm.value.weight && this.basicInfoForm.value.premiumRate) {

      if (((this.personalForm.value.tbType == '' && this.personalForm.value.riderTB > 0) || (this.personalForm.value.tbType != '' && (this.personalForm.value.riderTB == '' || this.personalForm.value.riderTB == 0 || this.personalForm.value.riderTB == null))) && !this.supplementaryIsnuranceHideAllBool && !this.supplementaryInsuranceBool) {
        this.errorTitle = "Niste uneli grupu težih bolesti ili niste odabrali iznos osigurane sume. Molimo Vas, proverite";
        this.modalService.open(this.alertModal, { centered: true })
      } else {

        let startDate =
          this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' +
          this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' +
          this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
        let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
        let standardOS = new StandardOS({ StartTime: startDate, EndTime: endDate, Duration: this.insuredSumAndPremiumForm.value.insurancePeriod, Age: this.insuredSumAndPremiumForm.value.accessAge, Gender: this.insuredSumAndPremiumForm.value.gender, HazardLevel: 2, PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment), CigarettesPerDay: this.insuredSumAndPremiumForm.value.cigarettesDaily, Height: this.insuredSumAndPremiumForm.value.height, Weight: this.insuredSumAndPremiumForm.value.weight, PremiumRate: this.basicInfoForm.value.premiumRate })

        standardOS.data.AdditionalInsurance = !this.supplementaryIsnuranceHideAllBool;

        if (!this.supplementaryInsuranceBool) {
          standardOS.data.DeathByAccident = this.personalForm.value.deathByAccident;

          standardOS.data.riderDeath = this.personalForm.value.riderDeath ? this.personalForm.value.riderDeath : 0;
          standardOS.data.tbType = this.personalForm.value.tbType != '' ? Number(this.personalForm.value.tbType) : 0;
          standardOS.data.riderTB = this.personalForm.value.riderTB ? this.personalForm.value.riderTB : 0;

          if (this.personalForm.value.includeMSO == '0') {
            standardOS.data.IncludeMSO = false;
          } else {
            standardOS.data.IncludeMSO = true;
          }
          if (this.personalForm.value.includeDNA == '0') {
            standardOS.data.IncludeDNA = false;
          } else {
            standardOS.data.IncludeDNA = true;
          }
          standardOS.data.SelectedPackage = 0;

          if (this.personalForm.value.invalidityByAccident) {
            if (this.personalForm.value.surgery) {
              standardOS.data.Surgery = this.personalForm.value.surgery;
            } else {
              standardOS.data.Surgery = 0;
            }
            if (this.personalForm.value.monthlyRent) {
              standardOS.data.MonthlyRent = this.personalForm.value.monthlyRent;
            } else {
              standardOS.data.MonthlyRent = 0;
            }
            if (this.personalForm.value.daylyFee) {
              standardOS.data.DailyFee = this.personalForm.value.daylyFee;
            } else {
              standardOS.data.DailyFee = 0
            }
            if (this.personalForm.value.treatmanExpenses) {
              standardOS.data.TreatmanExpenses = this.personalForm.value.treatmanExpenses;
            } else {
              standardOS.data.TreatmanExpenses = 0;
            }
            standardOS.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
          } else {
            standardOS.data.InvalidityByAccident = 0;
            standardOS.data.Surgery = 0;
            standardOS.data.MonthlyRent = 0;
            standardOS.data.DailyFee = 0;
            standardOS.data.TreatmanExpenses = 0;
            standardOS.data.IncludeMSO = false;
            standardOS.data.IncludeDNA = false;
          }

        } else {
          standardOS.data.DeathByAccident = 0;
          standardOS.data.InvalidityByAccident = 0;
          standardOS.data.Surgery = 0;
          standardOS.data.MonthlyRent = 0;
          standardOS.data.DailyFee = 0;
          standardOS.data.TreatmanExpenses = 0;
          standardOS.data.IncludeMSO = false;
          standardOS.data.IncludeDNA = false;
          standardOS.data.riderDeath = 0;
          standardOS.data.tbType = 0;
          standardOS.data.riderTB = 0;
          standardOS.data.SelectedPackage = parseInt(this.insuranceCoverageForm.value.incidentRadio);
        }
        // console.log(standardOS);
        if (this.supplementaryIsnuranceHideAllBool) {
          standardOS.data.SelectedPackage = 0;
          standardOS.data.DeathByAccident = 0;
          standardOS.data.InvalidityByAccident = 0;
          standardOS.data.Surgery = 0;
          standardOS.data.MonthlyRent = 0;
          standardOS.data.DailyFee = 0;
          standardOS.data.TreatmanExpenses = 0;
          standardOS.data.IncludeMSO = false;
          standardOS.data.IncludeDNA = false;
          standardOS.data.riderDeath = 0;
          standardOS.data.tbType = 0;
          standardOS.data.riderTB = 0;
        }

        if (
          this.insuredSumAndPremiumForm.value.insurancePeriod < 5 ||
          this.insuredSumAndPremiumForm.value.insurancePeriod > 30 ||
          (this.insuredSumAndPremiumForm.value.insurancePeriod + this.insuredSumAndPremiumForm.value.accessAge) > 75 ||
          this.insuredSumAndPremiumForm.value.accessAge < 14 ||
          this.insuredSumAndPremiumForm.value.accessAge > 65 ||
          this.insuredSumAndPremiumForm.value.cigarettesDaily > 100
        ) {
          this.errorTitle = "Podaci nisu ispravni";
          this.modalService.open(this.alertModal, { centered: true })
          console.log("InValid")
        } else {
          if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            if (this.personalForm.value.deathByAccident) {
              if (
                this.personalForm.value.deathByAccident > 100000 ||
                (this.personalForm.value.surgery && (this.personalForm.value.surgery < 1000 || this.personalForm.value.surgery > 15000 || (this.personalForm.value.surgery > this.personalForm.value.deathByAccident * 2))) ||
                (this.personalForm.value.invalidityByAccident && (this.personalForm.value.invalidityByAccident < this.personalForm.value.deathByAccident || this.personalForm.value.invalidityByAccident > this.personalForm.value.deathByAccident * 2)) ||
                (this.personalForm.value.monthlyRent && (this.personalForm.value.monthlyRent < 100 || this.personalForm.value.monthlyRent > 600))
              ) {
                this.errorTitle = "Podaci nisu ispravni";
                this.modalService.open(this.alertModal, { centered: true })
              } else {
                this.basicInfoForm.get('standardRate').setValue('')
                this.basicInfoForm.get('standardPlusRate').setValue('')
                this.basicInfoForm.get('standardProRate').setValue('')
                this.insuranceCoverageForm.get('deathByAccident').setValue('');
                this.insuranceCoverageForm.get('disabilityByAccident').setValue('');
                this.insuranceCoverageForm.get('surgery').setValue('');
                this.insuranceCoverageForm.get('monthlyRent').setValue('');
                this.insuranceCoverageForm.get('dailyFee').setValue('');
                this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue('');
                this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue('');
                this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue('');
                this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue('');
                this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue('');
                this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue('');
                this.insuranceCoverageForm.get('sumPremiumRateThird').setValue('');
                this.insuranceCoverageForm.get('sumPremiumRateForth').setValue('');
                this.insuranceCoverageForm.get('sumYearlyFirst').setValue('');
                this.insuranceCoverageForm.get('sumYearlySecound').setValue('');
                this.insuranceCoverageForm.get('sumYearlyThird').setValue('');
                this.insuranceCoverageForm.get('sumYearlyForth').setValue('');
                this.personalForm.get('additionalInsurance').setValue('');
                this.personalForm.get('sumPremiumRateFirst').setValue('');
                this.personalForm.get('sumPremiumRateSecond').setValue('');
                this.personalForm.get('sumPremiumRateThird').setValue('');
                this.personalForm.get('sumYearlyFirst').setValue('');
                this.personalForm.get('sumYearlySecond').setValue('');
                this.personalForm.get('sumYearlyThird').setValue('');
                this.noCovrageForm.get('sumPremiumRateFirst').setValue('')
                this.noCovrageForm.get('sumPremiumRateSecond').setValue('')
                this.noCovrageForm.get('sumPremiumRateThird').setValue('')
                this.noCovrageForm.get('sumYearlyFirst').setValue('')
                this.noCovrageForm.get('sumYearlySecond').setValue('')
                this.noCovrageForm.get('sumYearlyThird').setValue('')
                this.calculatorService.calculateStandartOS(standardOS)
                  .subscribe(
                    (x: any) => {

                      this.hideExport = true;
                      this.sentInformations = x;

                      console.log(x)
                      this.standardTableArray = x.standardTable;
                      this.standardPlusTableArray = x.standardPlusTable;
                      this.standardProTableArray = x.standardProTable;

                      this.basicInfoForm.get('standardRate').setValue(x.sumInsured.toFixed(2))
                      this.basicInfoForm.get('standardPlusRate').setValue(x.sumInsuredPlus.toFixed(2))
                      this.basicInfoForm.get('standardProRate').setValue(x.sumInsuredPro.toFixed(2))

                      this.insuranceCoverageForm.get('deathByAccident').setValue(x.deathByAccident);
                      this.insuranceCoverageForm.get('disabilityByAccident').setValue(x.invalidityByAccident);
                      this.insuranceCoverageForm.get('surgery').setValue(x.surgery);
                      this.insuranceCoverageForm.get('dailyFee').setValue(x.dailyFee);
                      this.insuranceCoverageForm.get('monthlyRent').setValue(x.monthlyRent);

                      this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue(x.package1PremiumRate.toFixed(2));
                      this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue(x.package2PremiumRate.toFixed(2));
                      this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue(x.package3PremiumRate.toFixed(2));
                      this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue(x.package4PremiumRate.toFixed(2));

                      this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue(x.package1TotalPremiumRate.toFixed(2));
                      this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue(x.package2TotalPremiumRate.toFixed(2));
                      this.insuranceCoverageForm.get('sumPremiumRateThird').setValue(x.package3TotalPremiumRate.toFixed(2));
                      this.insuranceCoverageForm.get('sumPremiumRateForth').setValue(x.package4TotalPremiumRate.toFixed(2));

                      this.insuranceCoverageForm.get('sumYearlyFirst').setValue(x.package1TotalPremiumRateYearly.toFixed(2));
                      this.insuranceCoverageForm.get('sumYearlySecound').setValue(x.package2TotalPremiumRateYearly.toFixed(2));
                      this.insuranceCoverageForm.get('sumYearlyThird').setValue(x.package3TotalPremiumRateYearly.toFixed(2));
                      this.insuranceCoverageForm.get('sumYearlyForth').setValue(x.package4TotalPremiumRateYearly.toFixed(2));

                      this.personalForm.get('additionalInsurance').setValue(x.personalizedPremiumRate.toFixed(2));

                      this.personalForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2));
                      this.personalForm.get('sumPremiumRateSecond').setValue(x.totalPremiumRate.toFixed(2));
                      this.personalForm.get('sumPremiumRateThird').setValue(x.totalPremiumRate.toFixed(2));

                      this.personalForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2));
                      this.personalForm.get('sumYearlySecond').setValue(x.totalPremiumRateYearly.toFixed(2));
                      this.personalForm.get('sumYearlyThird').setValue(x.totalPremiumRateYearly.toFixed(2));

                      this.noCovrageForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2))
                      this.noCovrageForm.get('sumPremiumRateSecond').setValue(x.totalPremiumRate.toFixed(2))
                      this.noCovrageForm.get('sumPremiumRateThird').setValue(x.totalPremiumRate.toFixed(2))

                      this.noCovrageForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2))
                      this.noCovrageForm.get('sumYearlySecond').setValue(x.totalPremiumRateYearly.toFixed(2))
                      this.noCovrageForm.get('sumYearlyThird').setValue(x.totalPremiumRateYearly.toFixed(2))

                      // console.log(this.hideExport)
                      this.standardMessageDoctor = ""
                      if (this.insuredSumAndPremiumForm.value.accessAge <= 45) {
                        //Standard program
                        switch (true) {
                          case (x.sumInsured <= 75000):
                            this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsured <= 100000):
                            this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsured <= 135000):
                            this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsured > 135000):
                            this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }
                        //Standard Plus program
                        switch (true) {
                          case (x.sumInsuredPlus <= 75000):
                            this.standardPlusMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus <= 100000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus <= 135000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus > 135000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }
                        //Standard Pro program
                        switch (true) {
                          case (x.sumInsuredPro <= 75000):
                            this.standardProMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsuredPro <= 100000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsuredPro <= 135000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsuredPro > 135000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }

                      } else if (this.insuredSumAndPremiumForm.value.accessAge >= 46 && this.insuredSumAndPremiumForm.value.accessAge <= 55) {

                        //Standard program
                        switch (true) {
                          case (x.sumInsured <= 50000):
                            this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsured <= 75000):
                            this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsured <= 100000):
                            this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsured > 100000):
                            this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }
                        //Standard Plus program
                        switch (true) {
                          case (x.sumInsuredPlus <= 50000):
                            this.standardPlusMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus <= 75000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus <= 100000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus > 100000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }
                        //Standard Pro program
                        switch (true) {
                          case (x.sumInsuredPro <= 50000):
                            this.standardProMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsuredPro <= 75000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsuredPro <= 100000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsuredPro > 100000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }

                      } else {

                        //Standard program
                        switch (true) {
                          case (x.sumInsured <= 30000):
                            this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsured <= 50000):
                            this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsured <= 75000):
                            this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsured > 75000):
                            this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }
                        //Standard Plus program
                        switch (true) {
                          case (x.sumInsuredPlus <= 30000):
                            this.standardPlusMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus <= 50000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus <= 75000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsuredPlus > 75000):
                            this.standardPlusMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }
                        //Standard Pro program
                        switch (true) {
                          case (x.sumInsuredPro <= 30000):
                            this.standardProMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (x.sumInsuredPro <= 50000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (x.sumInsuredPro <= 75000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (x.sumInsuredPro > 75000):
                            this.standardProMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }

                      }

                    },
                    (x: { error: String }) => {
                      console.log(x)
                      this.errorTitle = x.error;
                      this.modalService.open(this.alertModal, { centered: true })
                    }
                  );
              }
            } else {
              this.errorTitle = "Niste uneli sve tražene podatke";
              this.modalService.open(this.alertModal, { centered: true })
            }
          } else {
            this.basicInfoForm.get('standardRate').setValue('')
            this.basicInfoForm.get('standardPlusRate').setValue('')
            this.basicInfoForm.get('standardProRate').setValue('')
            this.insuranceCoverageForm.get('deathByAccident').setValue('');
            this.insuranceCoverageForm.get('disabilityByAccident').setValue('');
            this.insuranceCoverageForm.get('surgery').setValue('');
            this.insuranceCoverageForm.get('dailyFee').setValue('');
            this.insuranceCoverageForm.get('monthlyRent').setValue('');
            this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue('');
            this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue('');
            this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue('');
            this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue('');
            this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue('');
            this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue('');
            this.insuranceCoverageForm.get('sumPremiumRateThird').setValue('');
            this.insuranceCoverageForm.get('sumPremiumRateForth').setValue('');
            this.insuranceCoverageForm.get('sumYearlyFirst').setValue('');
            this.insuranceCoverageForm.get('sumYearlySecound').setValue('');
            this.insuranceCoverageForm.get('sumYearlyThird').setValue('');
            this.insuranceCoverageForm.get('sumYearlyForth').setValue('');
            this.personalForm.get('additionalInsurance').setValue('');
            this.personalForm.get('sumPremiumRateFirst').setValue('');
            this.personalForm.get('sumPremiumRateSecond').setValue('');
            this.personalForm.get('sumPremiumRateThird').setValue('');
            this.personalForm.get('sumYearlyFirst').setValue('');
            this.personalForm.get('sumYearlySecond').setValue('');
            this.personalForm.get('sumYearlyThird').setValue('');
            this.noCovrageForm.get('sumPremiumRateFirst').setValue('')
            this.noCovrageForm.get('sumPremiumRateSecond').setValue('')
            this.noCovrageForm.get('sumPremiumRateThird').setValue('')
            this.noCovrageForm.get('sumYearlyFirst').setValue('')
            this.noCovrageForm.get('sumYearlySecond').setValue('')
            this.noCovrageForm.get('sumYearlyThird').setValue('')
            this.calculatorService.calculateStandartOS(standardOS)
              .subscribe(
                (x: any) => {

                  this.hideExport = true;
                  this.sentInformations = x;

                  console.log(x)
                  this.standardTableArray = x.standardTable;
                  this.standardPlusTableArray = x.standardPlusTable;
                  this.standardProTableArray = x.standardProTable;

                  this.basicInfoForm.get('standardRate').setValue(x.sumInsured.toFixed(2))
                  this.basicInfoForm.get('standardPlusRate').setValue(x.sumInsuredPlus.toFixed(2))
                  this.basicInfoForm.get('standardProRate').setValue(x.sumInsuredPro.toFixed(2))

                  this.insuranceCoverageForm.get('deathByAccident').setValue(x.deathByAccident);
                  this.insuranceCoverageForm.get('disabilityByAccident').setValue(x.invalidityByAccident);
                  this.insuranceCoverageForm.get('surgery').setValue(x.surgery);
                  this.insuranceCoverageForm.get('dailyFee').setValue(x.dailyFee);
                  this.insuranceCoverageForm.get('monthlyRent').setValue(x.monthlyRent);

                  this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue(x.package1PremiumRate.toFixed(2));
                  this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue(x.package2PremiumRate.toFixed(2));
                  this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue(x.package3PremiumRate.toFixed(2));
                  this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue(x.package4PremiumRate.toFixed(2));

                  this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue(x.package1TotalPremiumRate.toFixed(2));
                  this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue(x.package2TotalPremiumRate.toFixed(2));
                  this.insuranceCoverageForm.get('sumPremiumRateThird').setValue(x.package3TotalPremiumRate.toFixed(2));
                  this.insuranceCoverageForm.get('sumPremiumRateForth').setValue(x.package4TotalPremiumRate.toFixed(2));

                  this.insuranceCoverageForm.get('sumYearlyFirst').setValue(x.package1TotalPremiumRateYearly.toFixed(2));
                  this.insuranceCoverageForm.get('sumYearlySecound').setValue(x.package2TotalPremiumRateYearly.toFixed(2));
                  this.insuranceCoverageForm.get('sumYearlyThird').setValue(x.package3TotalPremiumRateYearly.toFixed(2));
                  this.insuranceCoverageForm.get('sumYearlyForth').setValue(x.package4TotalPremiumRateYearly.toFixed(2));

                  this.personalForm.get('additionalInsurance').setValue(x.personalizedPremiumRate.toFixed(2));

                  this.personalForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2));
                  this.personalForm.get('sumPremiumRateSecond').setValue(x.totalPremiumRate.toFixed(2));
                  this.personalForm.get('sumPremiumRateThird').setValue(x.totalPremiumRate.toFixed(2));

                  this.personalForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2));
                  this.personalForm.get('sumYearlySecond').setValue(x.totalPremiumRateYearly.toFixed(2));
                  this.personalForm.get('sumYearlyThird').setValue(x.totalPremiumRateYearly.toFixed(2));

                  this.noCovrageForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2))
                  this.noCovrageForm.get('sumPremiumRateSecond').setValue(x.totalPremiumRate.toFixed(2))
                  this.noCovrageForm.get('sumPremiumRateThird').setValue(x.totalPremiumRate.toFixed(2))

                  this.noCovrageForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2))
                  this.noCovrageForm.get('sumYearlySecond').setValue(x.totalPremiumRateYearly.toFixed(2))
                  this.noCovrageForm.get('sumYearlyThird').setValue(x.totalPremiumRateYearly.toFixed(2))


                  this.standardMessageDoctor = ""
                  if (this.insuredSumAndPremiumForm.value.accessAge <= 45) {
                    //Standard program
                    switch (true) {
                      case (x.sumInsured <= 75000):
                        this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsured <= 100000):
                        this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsured <= 135000):
                        this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsured > 135000):
                        this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }
                    //Standard Plus program
                    switch (true) {
                      case (x.sumInsuredPlus <= 75000):
                        this.standardPlusMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus <= 100000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus <= 135000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus > 135000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }
                    //Standard Pro program
                    switch (true) {
                      case (x.sumInsuredPro <= 75000):
                        this.standardProMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsuredPro <= 100000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsuredPro <= 135000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsuredPro > 135000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }

                  } else if (this.insuredSumAndPremiumForm.value.accessAge >= 46 && this.insuredSumAndPremiumForm.value.accessAge <= 55) {

                    //Standard program
                    switch (true) {
                      case (x.sumInsured <= 50000):
                        this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsured <= 75000):
                        this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsured <= 100000):
                        this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsured > 100000):
                        this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }
                    //Standard Plus program
                    switch (true) {
                      case (x.sumInsuredPlus <= 50000):
                        this.standardPlusMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus <= 75000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus <= 100000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus > 100000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }
                    //Standard Pro program
                    switch (true) {
                      case (x.sumInsuredPro <= 50000):
                        this.standardProMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsuredPro <= 75000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsuredPro <= 100000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsuredPro > 100000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }

                  } else {

                    //Standard program
                    switch (true) {
                      case (x.sumInsured <= 30000):
                        this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsured <= 50000):
                        this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsured <= 75000):
                        this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsured > 75000):
                        this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }
                    //Standard Plus program
                    switch (true) {
                      case (x.sumInsuredPlus <= 30000):
                        this.standardPlusMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus <= 50000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus <= 75000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsuredPlus > 75000):
                        this.standardPlusMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }
                    //Standard Pro program
                    switch (true) {
                      case (x.sumInsuredPro <= 30000):
                        this.standardProMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (x.sumInsuredPro <= 50000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (x.sumInsuredPro <= 75000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (x.sumInsuredPro > 75000):
                        this.standardProMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }

                  }
                },
                (x: { error: String }) => {
                  console.log(x)
                  this.errorTitle = x.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              );
          }
        }
      }
    } else {
      this.errorTitle = "Niste uneli sve tražene podatke";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }

  resetAllForms() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', cigarettesDaily: '0' })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoForm.reset();
    this.healthForm.reset({ agreeToHealthQuestionnaire: true })
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.sendInfoService.sendInfo(true)
    this.platimatikForm.reset()
    this.standardTableArray = []
    this.standardPlusTableArray = []
    this.standardProTableArray = []
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.insuranceCoverageForm.reset({ incidentRadio: '3', planRadio: '2' })
    this.personalForm.reset({ includeMSO: '0', includeDNA: '0', planRadio: '2' })
    this.noCovrageForm.reset({ planRadio: '2' })
    this.hideExport = false
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1', offer: true, redemptionAndCapitalization: false, proContract: false, terms: false, doctor: false })
    this.insuranceUsers = []
    this.validInsuranceAndSumPremium = false;
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.healthQuestionnaireBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    // this.basicInfo = new BasicInformations({});
  }

  accountNumberSetBank() {
    if (this.platimatikForm.value.firstThreeAccountNumber.length == 3) {
      this.bankService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
        .subscribe(
          (res: Array<{ code: String, name: String, swift: String }>) => {
            for (let i = 0; i < res.length; i++) {
              if (res[i].code == this.platimatikForm.value.firstThreeAccountNumber) {
                this.platimatikForm.get('bankName').setValue(res[i].name);
                this.platimatikForm.get('bankBic').setValue(res[i].swift);
                this.accNumber.nativeElement.focus();
                break;
              }
            }
          }
        )
    } else if (this.platimatikForm.value.firstThreeAccountNumber.length < 3) {
      this.platimatikForm.get('bankName').setValue('');
      this.platimatikForm.get('bankBic').setValue('');
    }
  }

  checkAccount() {
    if (this.platimatikForm.value.middleAccountNumber.length <= 13) {
      this.platimatikForm.get('middleAccountNumber').setValue('0'.repeat(13 - this.platimatikForm.value.middleAccountNumber.length) + this.platimatikForm.value.middleAccountNumber)
    }
  }

  exportpft() {
    // console.log(this.basicInfo);
    let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
    let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
    let exportpdf = new StandardOSExport({
      ContratcorType: this.basicInfo.data.contractorType == '1' ? '1' : '0',
      CompanyName: this.basicInfo.data.contractorResponsibleName,
      Firstname: this.basicInfo.data.contractorFirstname,
      Lastname: this.basicInfo.data.contractorLastname,
      JMBG: this.basicInfo.data.contractorJMBG,
      Email: this.basicInfo.data.contractorEmail,
      TaxID: this.basicInfo.data.contractorPIB,
      CompanyID: this.basicInfo.data.contractorID,
      Address: this.basicInfo.data.contractorAddress,
      Settlement: this.basicInfo.data.contractorSettlement,
      PostalCode: this.basicInfo.data.contractorPostalCode.toString(),
      ContactPhone: this.basicInfo.data.contractorPhonenumber,
      DeliveryAddress: this.basicInfo.data.contractorAddressOfDelivery,
      InsureeFirstname: this.basicInfo.data.insuredFirstname,
      InsureeLastname: this.basicInfo.data.insuredLastname,
      InsureeAddress: this.basicInfo.data.insuredAddress,
      InsureeSettlement: this.basicInfo.data.insuredSettlement,
      InsureePostalCode: this.basicInfo.data.insuredPostalCode.toString(),
      InsureeJMBG: this.basicInfo.data.insuredJMBG,
      InsureeContactPhone1: this.basicInfo.data.insuredMobile,
      InsureeContactPhone2: '',
      InsureeOccupation: this.basicInfo.data.insuredJob,
      StartTime: startDate,
      EndTime: endDate,
      Duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
      Age: this.insuredSumAndPremiumForm.value.accessAge,
      Gender: this.insuredSumAndPremiumForm.value.gender,
      HazardLevel: 2,
      CigarettesPerDay: this.insuredSumAndPremiumForm.value.cigarettesDaily,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      Height: this.insuredSumAndPremiumForm.value.height,
      Weight: this.insuredSumAndPremiumForm.value.weight,
      PremiumRate: this.basicInfoForm.value.premiumRate,
      Offer: this.checkBoxesForm.value.offer,
      RedemptionAndCapitalization: this.checkBoxesForm.value.redemptionAndCapitalization,
      ProContract: this.checkBoxesForm.value.proContract,
      Terms: this.checkBoxesForm.value.terms,
      SumInsured: this.sentInformations.sumInsured,
      SumInsuredPlus: this.sentInformations.sumInsuredPlus,
      SumInsuredPro: this.sentInformations.sumInsuredPro,
      AdditionalInsurance: !this.supplementaryIsnuranceHideAllBool,
      AdditionalDocumentation: this.checkBoxesForm.value.doctor,
    });
    if (this.basicInfo.data.insuredDOB) {
      exportpdf.data.InsureeDOB = this.basicInfo.data.insuredDOB;
    } else {
      exportpdf.data.InsureeDOB = '';
    }
    if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      console.log("Personal")
      exportpdf.data.DeathByAccident = this.personalForm.value.deathByAccident;
      exportpdf.data.SelectedPackage = 0;
      exportpdf.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

      exportpdf.data.riderDeath = this.personalForm.value.riderDeath ? Number(this.personalForm.value.riderDeath) : 0;
      exportpdf.data.tbType = Number(this.personalForm.value.tbType);
      exportpdf.data.riderTB = this.personalForm.value.riderTB ? Number(this.personalForm.value.riderTB) : 0;
      if (this.personalForm.value.includeMSO == '0') {
        exportpdf.data.IncludeMSO = false;
      } else {
        exportpdf.data.IncludeMSO = true;
      }
      if (this.personalForm.value.includeDNA == '0') {
        exportpdf.data.IncludeDNA = false;
      } else {
        exportpdf.data.IncludeDNA = true;
      }
      if (this.personalForm.value.invalidityByAccident) {
        if (this.personalForm.value.surgery) {
          exportpdf.data.Surgery = this.personalForm.value.surgery;
        } else {
          exportpdf.data.Surgery = 0;
        }
        if (this.personalForm.value.monthlyRent) {
          exportpdf.data.MonthlyRent = this.personalForm.value.monthlyRent;
        } else {
          exportpdf.data.MonthlyRent = 0;
        }
        if (this.personalForm.value.daylyFee) {
          exportpdf.data.DailyFee = this.personalForm.value.daylyFee;
        } else {
          exportpdf.data.DailyFee = 0
        }
        if (this.personalForm.value.treatmanExpenses) {
          exportpdf.data.TreatmanExpenses = this.personalForm.value.treatmanExpenses;
        } else {
          exportpdf.data.TreatmanExpenses = 0;
        }
        exportpdf.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
      } else {
        exportpdf.data.InvalidityByAccident = 0;
        exportpdf.data.Surgery = 0;
        exportpdf.data.MonthlyRent = 0;
        exportpdf.data.DailyFee = 0;
        exportpdf.data.TreatmanExpenses = 0;
        exportpdf.data.IncludeMSO = false;
        exportpdf.data.IncludeDNA = false;
      }
      switch (this.personalForm.value.planRadio) {
        case '1':
          exportpdf.data.StandardType = 0;
          exportpdf.data.StandardTable = this.sentInformations.standardTable
          exportpdf.data.TotalPremiumRate = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.totalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.totalPremiumRateYearly;
          break;
        case '2':
          exportpdf.data.StandardType = 1;
          exportpdf.data.StandardTable = this.sentInformations.standardPlusTable
          exportpdf.data.TotalPremiumRate = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.totalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.totalPremiumRateYearly;
          break;
        case '3':
          exportpdf.data.StandardType = 2;
          exportpdf.data.StandardTable = this.sentInformations.standardProTable
          exportpdf.data.TotalPremiumRate = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.totalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.totalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.totalPremiumRateYearly;
          break;
        default:
          break;
      }
    } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      console.log("Dopunsko")
      exportpdf.data.SelectedPackage = parseInt(this.insuranceCoverageForm.value.incidentRadio);
      exportpdf.data.DeathByAccident = this.sentInformations.deathByAccident;
      exportpdf.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
      exportpdf.data.MonthlyRent = this.sentInformations.monthlyRent;
      exportpdf.data.TreatmanExpenses = 0;
      exportpdf.data.DailyFee = 0;
      exportpdf.data.riderDeath = 0;
      exportpdf.data.tbType = 0;
      exportpdf.data.riderTB = 0;
      switch (this.insuranceCoverageForm.value.incidentRadio) {
        case '1':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package1TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.package1TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.package1TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package1TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.package1TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.package1TotalPremiumRateYearly;
          exportpdf.data.Surgery = 0;
          exportpdf.data.IncludeMSO = false;
          exportpdf.data.IncludeDNA = false;
          break;
        case '2':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package2TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.package2TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.package2TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package2TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.package2TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.package2TotalPremiumRateYearly;
          exportpdf.data.Surgery = this.sentInformations.surgery;
          exportpdf.data.IncludeMSO = true;
          exportpdf.data.IncludeDNA = false;
          break;
        case '3':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package3TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.package3TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.package3TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package3TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.package3TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.package3TotalPremiumRateYearly;
          exportpdf.data.Surgery = this.sentInformations.surgery;
          exportpdf.data.DailyFee = this.sentInformations.dailyFee;
          exportpdf.data.IncludeMSO = false;
          exportpdf.data.IncludeDNA = false;
          break;
        case '4':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package4TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePlus = this.sentInformations.package4TotalPremiumRate;
          exportpdf.data.TotalPremiumRatePro = this.sentInformations.package4TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package4TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.package4TotalPremiumRateYearly;
          exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.package4TotalPremiumRateYearly;
          exportpdf.data.Surgery = 0;
          exportpdf.data.IncludeMSO = true;
          exportpdf.data.IncludeDNA = true;
          break;
        default:
          break;
      }
      switch (this.insuranceCoverageForm.value.planRadio) {
        case '1':
          exportpdf.data.StandardTable = this.sentInformations.standardTable
          exportpdf.data.StandardType = 0;
          break;
        case '2':
          exportpdf.data.StandardTable = this.sentInformations.standardPlusTable
          exportpdf.data.StandardType = 1;
          break;
        case '3':
          exportpdf.data.StandardTable = this.sentInformations.standardProTable
          exportpdf.data.StandardType = 2;
          break;
        default:
          break;
      }
    } else {
      exportpdf.data.SelectedPackage = 0;
      exportpdf.data.DeathByAccident = 0;
      exportpdf.data.InvalidityByAccident = 0;
      exportpdf.data.Surgery = 0;
      exportpdf.data.TreatmanExpenses = 0;
      exportpdf.data.DailyFee = 0;
      exportpdf.data.MonthlyRent = 0;
      exportpdf.data.riderDeath = 0;
      exportpdf.data.tbType = 0;
      exportpdf.data.riderTB = 0;
      exportpdf.data.IncludeMSO = false;
      exportpdf.data.IncludeDNA = false;
      exportpdf.data.AdditionalPremiumRate = 0;
      exportpdf.data.TotalPremiumRate = this.sentInformations.totalPremiumRate;
      exportpdf.data.TotalPremiumRatePlus = this.sentInformations.totalPremiumRate;
      exportpdf.data.TotalPremiumRatePro = this.sentInformations.totalPremiumRate;
      exportpdf.data.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
      exportpdf.data.TotalPremiumRatePlusYearly = this.sentInformations.totalPremiumRateYearly;
      exportpdf.data.TotalPremiumRateProYearly = this.sentInformations.totalPremiumRateYearly;
      // console.log("Nema ni jednog ni drugog")
      switch (this.noCovrageForm.value.planRadio) {
        case '1':
          exportpdf.data.StandardTable = this.sentInformations.standardTable
          exportpdf.data.StandardType = 0;
          break;
        case '2':
          exportpdf.data.StandardTable = this.sentInformations.standardPlusTable
          exportpdf.data.StandardType = 1;
          break;
        case '3':
          exportpdf.data.StandardTable = this.sentInformations.standardProTable
          exportpdf.data.StandardType = 2;
          break;
        default:
          break;
      }
    }

    console.log(exportpdf);
    this.exportCalculatorService.exportStandardOS(exportpdf)
      .subscribe(
        x => {
          console.log(x)
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  changeUserRole(num) {
    this.getRoles(num);
    this.insuranceUsers = [];
  }

  draftModelFull: StandardOSOffer;
  saveDraft() {
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
        this.saveDraftService.addInfo();
        console.log("Nije uneto ime i prezime")
      } else {
        if (
          ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
        ) {
          this.errorTitle = "Ne možete napraviti draft ponudu ukoliko godisnja premija nije manja od 1500 €";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          this.draftModelFull = new StandardOSOffer({
            InsuranceStart: '',
            InsuranceEnd: '',
            OfferNumber: "",
            OfferType: 1,
            ContractorID: 0,
            InsureeID: 0,
            OneTimePayment: false,
            PaymentPeriodMonths: 0,
            Interest: 0,
            CreditAmount: 0,
            AdditionalIL: false,
            AdditionalBF: false,
            AdditionalAS: false,
            Contractor: new OfferClient(
              this.basicInfo.data.contractorType == '1' ? '1' : '0',
              this.basicInfo.data.contractorFirstname,
              this.basicInfo.data.contractorLastname,
              this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : '',
              this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : '',
              this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : '',
              this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : '',
              this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : '',
              this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : '',
              this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode.toString() : "",
              this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : '',
              this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : '',
              this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery.toString() : "",
              0,
              "",
              "",
              0
            ),
            Insuree: new OfferInsuree(
              this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : '',
              this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : '',
              this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : '',
              this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : '',
              this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : '',
              this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : '',
              this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : '',
              this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : '',
              this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode.toString() : "",
              this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : '',
              0,
              0,
              0
            ),
            Gender: this.insuredSumAndPremiumForm.value.gender,
            ContractorIsInsuree: this.basicInfo.data.contractorCopy,
            HazardLevel: 2,
            CigarettesPerDay: this.insuredSumAndPremiumForm.value.cigarettesDaily,
            Height: this.insuredSumAndPremiumForm.value.height,
            Weight: this.insuredSumAndPremiumForm.value.weight,
            AdditionalInsuranceDeath: false,
            PaymentPeriodOut: 0,
            PaymentPeriodIn: 0,
            StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
            Duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
            PremiumRate: this.basicInfoForm.value.premiumRate,
            PaymentPeriod: 0,
            RentPaymentFrequency: 0,
            RentPayment: 0,
            PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
            PaymentType: parseInt(this.insuredSumAndPremiumForm.value.methodPayment),
            ClientStatusID: null,
            PaymentInCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayment),
            PaymentOutCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayout),
            Comment: "",
            UserID: this.userId,
            NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
            Verified: this.checkBoxesForm.value.confirmVeracity,
            Verified2: this.checkBoxesForm.value.confirmVeracity,
            Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false,
            RedemptionAndCapitalization: new RedemptionAndCapitalizations(),
            Indexation: this.insuredSumAndPremiumForm.value.indexation == '' ? null : this.insuredSumAndPremiumForm.value.indexation == '0' ? false : true,
            Beneficiaries: this.insuranceUsers.length > 0 ? this.insuranceUsers : null,
            HealthQuestionnaire: new HealthQuestionnaire(
              0,
              this.healthForm.value.threeMonthStayAbroad == '' ? null : this.healthForm.value.threeMonthStayAbroad == '0' ? true : false,
              this.healthForm.value.threeMonthStayAbroad == '0' ? this.healthForm.value.threeMonthStayAbroadDescription : '',
              this.healthForm.value.deniedAcceptedRequest == '' ? null : this.healthForm.value.deniedAcceptedRequest == '0' ? true : false,
              this.healthForm.value.deniedAcceptedRequest == '0' ? this.healthForm.value.deniedacceptedRequestDescription : '',
              this.healthForm.value.sportActivity == '' ? null : this.healthForm.value.sportActivity == '0' ? true : false,
              this.healthForm.value.sportActivity == '0' ? this.healthForm.value.sportActivityDescription : '',
              this.healthForm.value.constantDoctorTreats == '' ? null : this.healthForm.value.constantDoctorTreats == '0' ? true : false,
              this.healthForm.value.constantDoctorTreats == '0' ? this.healthForm.value.constantDoctorTreatsDescription : '',
              this.healthForm.value.specialMedicalExamination == '' ? null : this.healthForm.value.specialMedicalExamination == '0' ? true : false,
              this.healthForm.value.specialMedicalExamination == '0' ? this.healthForm.value.specialMedicalExaminationDescription : '',
              this.healthForm.value.takingMedicines == '' ? null : this.healthForm.value.takingMedicines == '0' ? true : false,
              this.healthForm.value.takingMedicines == '0' ? this.healthForm.value.takingMedicinesDescription : '',
              this.healthForm.value.alcoholOrIntoxicants == '' ? null : this.healthForm.value.alcoholOrIntoxicants == '0' ? true : false,
              this.healthForm.value.alcoholOrIntoxicants == '0' ? this.healthForm.value.alcoholOrIntoxicantsDescription : '',
              this.healthForm.value.helpForAlcoholAddiction == '' ? null : this.healthForm.value.helpForAlcoholAddiction == '0' ? true : false,
              this.healthForm.value.helpForAlcoholAddiction == '0' ? this.healthForm.value.helpForAlcoholAddictionDescription : '',
              this.healthForm.value.consumeCigarettes == '' ? null : this.healthForm.value.consumeCigarettes == '0' ? true : false,
              this.healthForm.value.consumeCigarettes == '0' ? this.healthForm.value.consumeCigarettesDescription : '',
              this.healthForm.value.seriousIllness == '' ? null : this.healthForm.value.seriousIllness == '0' ? true : false,
              this.healthForm.value.seriousIllness == '0' ? this.healthForm.value.seriousIllnessDescription : '',
              this.healthForm.value.dangerAtWork == '' ? null : this.healthForm.value.dangerAtWork == '0' ? true : false,
              this.healthForm.value.dangerAtWork == '0' ? this.healthForm.value.dangerAtWorkDescription : '',
              this.healthForm.value.tenYearMedicalTests == '' ? null : this.healthForm.value.tenYearMedicalTests == '0' ? true : false,
              this.healthForm.value.tenYearMedicalTests == '0' ? this.healthForm.value.tenYearmedicalTestsDescription : '',
              this.healthForm.value.thirtyDaysIncapable == '' ? null : this.healthForm.value.thirtyDaysIncapable == '0' ? true : false,
              this.healthForm.value.thirtyDaysIncapable == '0' ? this.healthForm.value.thirtyDaysIncapableDescription : '',
              this.healthForm.value.levelOfInvaliditet == '' ? null : this.healthForm.value.levelOfInvaliditet == '0' ? true : false,
              this.healthForm.value.levelOfInvaliditet == '0' ? this.healthForm.value.levelOfInvaliditetDescription : '',
              this.healthForm.value.newFifteenthQuestion == '0' ? true : this.healthForm.value.newFifteenthQuestion == '1' ? false : null,
              this.healthForm.value.newFifteenthQuestion == '0' ? this.healthForm.value.newFifteenthQuestionDescription : '',
              this.healthForm.value.nameOfDoctor,
              this.healthForm.value.familySickness == '0' ? true : this.healthForm.value.familySickness == '1' ? false : null,
              this.healthForm.value.familySickness == '0' ? this.healthForm.value.familySicknessDescription : '',
              this.healthForm.value.agreeToHealthQuestionnaire
            ),
            FATCAQuestionnaire: new FATCAQuestionnaire(
              0,
              null,
              null,
              null,
              null,
              null,
              null
            ),
            SPNFTForm: new SPNFTQuestionnaire(
              0,
              this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
              this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
              this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
              this.spnftForm.value.jmbg ? this.spnftForm.value.jmbg : '',
              '',
              this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
              this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
              this.spnftForm.value.postalCode ? this.spnftForm.value.postalCode.toString() : "",
              this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
              this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
              this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
              this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
              this.spnftForm.value.representativeJmbg ? this.spnftForm.value.representativeJmbg : '',
              this.spnftForm.value.pib ? this.spnftForm.value.pib : '',
              this.spnftForm.value.mb ? this.spnftForm.value.mb : '',
              this.spnftForm.value.typeOfDocument ? this.spnftForm.value.typeOfDocument : '',
              this.spnftForm.value.numberOfDocument ? this.spnftForm.value.numberOfDocument : '',
              this.spnftForm.value.dateOfIssuringDocument ? this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0] : '',
              this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
              this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
              this.spnftForm.value.officialCloseFamily == 0 ? false : true,
              this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
              this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
              this.spnftForm.value.cutomerAnotherPerson == '' ? null : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
              this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
              this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
              this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
              this.spnftForm.value.jmbgOnBehalf ? this.spnftForm.value.jmbgOnBehalf : '',
              this.spnftForm.get('dobOnBehalf').value ? this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0] : '',
              this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
              this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
              this.spnftForm.value.postalCodeOnBehalf ? this.spnftForm.value.postalCodeOnBehalf.toString() : '',
              this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
              this.spnftForm.value.idTypeOnBehalf ? this.spnftForm.value.idTypeOnBehalf : '',
              this.spnftForm.value.idNumberOnBehalf ? this.spnftForm.value.idNumberOnBehalf : '',
              this.spnftForm.value.idDate ? this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0] : '',
              this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
              this.spnftForm.value.purposeOfBusinessRelation != '' ? this.spnftForm.value.purposeOfBusinessRelation : null,
              this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
              this.spnftForm.value.originOfProperty != '' ? this.spnftForm.value.originOfProperty : null,
              this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
            ),
            PlatimatikForm: new PLATIMATICQuestionnaire(
              0,
              this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
              this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
              this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
              this.platimatikForm.value.postalCode ? this.platimatikForm.value.postalCode.toString() : "",
              this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
              this.platimatikForm.value.jmbg ? this.platimatikForm.value.jmbg : '',
              this.platimatikForm.value.bankName ? this.platimatikForm.value.bankName : '',
              this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
              this.platimatikForm.value.bankBic ? this.platimatikForm.value.bankBic : '',
              '',
              1,
              this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
              this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
              this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
              this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : ''
            )
          })
          if (this.basicInfo.data.contractorType == '1') {
            this.draftModelFull.data.FATCAQuestionnaire.Q1NP = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q2NP = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
          } else {
            this.draftModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q1LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q2LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q3LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q4LE = false;
          }

          let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
          let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
          this.draftModelFull.data.InsuranceStart = startDate;
          this.draftModelFull.data.InsuranceEnd = endDate;
          this.draftModelFull.data.RedemptionAndCapitalization.OfferID = 0;

          // console.log(JSON.stringify(this.sentInformations.standardTable))
          if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            // console.log("Personal")
            this.draftModelFull.data.AdditionalInsuranceType = 0;
            this.draftModelFull.data.DeathByAccident = this.personalForm.value.deathByAccident;
            this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

            this.draftModelFull.data.AdditionalRiderDeath = this.personalForm.value.riderDeath;
            this.draftModelFull.data.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
            this.draftModelFull.data.AdditionalRiderTB = this.personalForm.value.riderTB;
            if (this.personalForm.value.includeMSO == '0') {
              this.draftModelFull.data.IncludeMSO = false;
            } else {
              this.draftModelFull.data.IncludeMSO = true;
            }
            if (this.personalForm.value.includeDNA == '0') {
              this.draftModelFull.data.IncludeDNA = false;
            } else {
              this.draftModelFull.data.IncludeDNA = true;
            }
            if (this.personalForm.value.invalidityByAccident) {
              if (this.personalForm.value.surgery) {
                this.draftModelFull.data.Surgery = this.personalForm.value.surgery;
              } else {
                this.draftModelFull.data.Surgery = null;
              }
              if (this.personalForm.value.monthlyRent) {
                this.draftModelFull.data.MonthlyRent = this.personalForm.value.monthlyRent;
              } else {
                this.draftModelFull.data.MonthlyRent = null;
              }
              if (this.personalForm.value.daylyFee) {
                this.draftModelFull.data.DailyFee = this.personalForm.value.daylyFee;
              } else {
                this.draftModelFull.data.DailyFee = null
              }
              if (this.personalForm.value.treatmanExpenses) {
                this.draftModelFull.data.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
              } else {
                this.draftModelFull.data.TreatmentExpenses = null;
              }
              this.draftModelFull.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
            } else {
              this.draftModelFull.data.InvalidityByAccident = null;
              this.draftModelFull.data.Surgery = null;
              this.draftModelFull.data.MonthlyRent = null;
              this.draftModelFull.data.DailyFee = null;
              this.draftModelFull.data.TreatmentExpenses = null;
              this.draftModelFull.data.IncludeMSO = false;
              this.draftModelFull.data.IncludeDNA = false;
            }
            if (this.personalForm.value.planRadio == '1') {
              this.draftModelFull.data.ProductType = 0;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.personalForm.value.planRadio == '2') {
              this.draftModelFull.data.ProductType = 1;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.draftModelFull.data.ProductType = 2;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            this.draftModelFull.data.AdditionalInsuranceType = this.insuranceCoverageForm.value.incidentRadio;
            // console.log("Dopunsko")
            this.draftModelFull.data.DeathByAccident = this.sentInformations.deathByAccident;
            this.draftModelFull.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
            this.draftModelFull.data.MonthlyRent = this.sentInformations.monthlyRent;
            this.draftModelFull.data.TreatmentExpenses = null;
            this.draftModelFull.data.DailyFee = null;
            switch (this.insuranceCoverageForm.value.incidentRadio) {
              case '1':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                this.draftModelFull.data.Surgery = null;
                this.draftModelFull.data.IncludeMSO = false;
                this.draftModelFull.data.IncludeDNA = false;
                break;
              case '2':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                this.draftModelFull.data.Surgery = this.sentInformations.surgery;
                this.draftModelFull.data.IncludeMSO = true;
                this.draftModelFull.data.IncludeDNA = false;
                break;
              case '3':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                this.draftModelFull.data.Surgery = this.sentInformations.surgery;
                this.draftModelFull.data.DailyFee = this.sentInformations.dailyFee;
                this.draftModelFull.data.IncludeMSO = false;
                this.draftModelFull.data.IncludeDNA = false;
                break;
              case '4':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                this.draftModelFull.data.Surgery = null;
                this.draftModelFull.data.IncludeMSO = true;
                this.draftModelFull.data.IncludeDNA = true;
                break;
              default:
                break;
            }
            if (this.insuranceCoverageForm.value.planRadio == '1') {
              this.draftModelFull.data.ProductType = 0;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.insuranceCoverageForm.value.planRadio == '2') {
              this.draftModelFull.data.ProductType = 1;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.draftModelFull.data.ProductType = 2;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          } else {
            this.draftModelFull.data.AdditionalInsuranceType = 5;
            this.draftModelFull.data.DeathByAccident = null;
            this.draftModelFull.data.InvalidityByAccident = null;
            this.draftModelFull.data.Surgery = null;
            this.draftModelFull.data.TreatmentExpenses = null;
            this.draftModelFull.data.DailyFee = null;
            this.draftModelFull.data.MonthlyRent = null;
            this.draftModelFull.data.IncludeMSO = false;
            this.draftModelFull.data.IncludeDNA = false;
            this.draftModelFull.data.AdditionalPremiumRate = 0;
            if (this.noCovrageForm.value.planRadio == '1') {
              this.draftModelFull.data.ProductType = 0;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.noCovrageForm.value.planRadio == '2') {
              this.draftModelFull.data.ProductType = 1;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.draftModelFull.data.ProductType = 2;
              this.draftModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          }
        }
        console.log(this.draftModelFull)
        this.offerService.createDraftOffer(this.draftModelFull)
          .then(
            x => {
              this.successTitle = "Uspešno ste kreirali draft ponudu";
              this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
              this.resetAllForms()
              this.insuranceUsers = []
              this.formPlatimatikBool = false;
              this.formSpnftBool = false;
              this.noticeFatcaBool = false;
              this.healthQuestionnaireBool = false;
              this.calculcatorUsersBool = false;
              this.validInsuranceAndSumPremium = false;
              this.validUser = false;
              this.validSPNFT = false;
              this.validPLATIMATIK = false;
            },
            e => console.log(e)
          )
      }
    }
  }


  updateDraft(draftTo: Number) {
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
        this.saveDraftService.addInfo();
        console.log("Nije uneto ime i prezime")
      } else {
        if (
          ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
        ) {
          this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          this.updateDraftModelFull.data.OfferType = 1
          this.updateDraftModelFull.data.OneTimePayment = false
          this.updateDraftModelFull.data.PaymentPeriodMonths = 0
          this.updateDraftModelFull.data.Interest = 0
          this.updateDraftModelFull.data.CreditAmount = 0
          this.updateDraftModelFull.data.AdditionalIL = false
          this.updateDraftModelFull.data.AdditionalBF = false
          this.updateDraftModelFull.data.AdditionalAS = false

          this.updateDraftModelFull.data.Contractor.ClientType = this.basicInfo.data.contractorType == '1' ? '1' : '0'
          this.updateDraftModelFull.data.Contractor.Firstname = this.basicInfo.data.contractorFirstname
          this.updateDraftModelFull.data.Contractor.Lastname = this.basicInfo.data.contractorLastname
          this.updateDraftModelFull.data.Contractor.CompanyName = this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : ''
          this.updateDraftModelFull.data.Contractor.JMBG = this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : ''
          this.updateDraftModelFull.data.Contractor.Mobile = this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : ''
          this.updateDraftModelFull.data.Contractor.Email = this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : ''
          this.updateDraftModelFull.data.Contractor.Address = this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : ''
          this.updateDraftModelFull.data.Contractor.Settlement = this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : ''
          this.updateDraftModelFull.data.Contractor.PostalCode = this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode : ''
          this.updateDraftModelFull.data.Contractor.DeliveryAddress = this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : ''
          this.updateDraftModelFull.data.Contractor.DeliverySettlement = this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : ''
          this.updateDraftModelFull.data.Contractor.DeliveryPostalCode = this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery : ''

          this.updateDraftModelFull.data.Insuree.Firstname = this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : ''
          this.updateDraftModelFull.data.Insuree.Lastname = this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : ''
          this.updateDraftModelFull.data.Insuree.JMBG = this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : ''
          this.updateDraftModelFull.data.Insuree.DOB = this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : ''
          this.updateDraftModelFull.data.Insuree.Mobile = this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : ''
          this.updateDraftModelFull.data.Insuree.Email = this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : ''
          this.updateDraftModelFull.data.Insuree.Address = this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : ''
          this.updateDraftModelFull.data.Insuree.Settlement = this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : ''
          this.updateDraftModelFull.data.Insuree.PostalCode = this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode : ''
          this.updateDraftModelFull.data.Insuree.Occupation = this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : ''

          this.updateDraftModelFull.data.Gender = this.insuredSumAndPremiumForm.value.gender
          this.updateDraftModelFull.data.ContractorIsInsuree = this.basicInfo.data.contractorCopy
          this.updateDraftModelFull.data.HazardLevel = 2
          this.updateDraftModelFull.data.CigarettesPerDay = this.insuredSumAndPremiumForm.value.cigarettesDaily
          this.updateDraftModelFull.data.Height = this.insuredSumAndPremiumForm.value.height
          this.updateDraftModelFull.data.Weight = this.insuredSumAndPremiumForm.value.weight
          this.updateDraftModelFull.data.AdditionalInsuranceDeath = false
          this.updateDraftModelFull.data.PaymentPeriodOut = 0
          this.updateDraftModelFull.data.PaymentPeriodIn = 0
          this.updateDraftModelFull.data.StartingAge = this.insuredSumAndPremiumForm.value.accessAge
          this.updateDraftModelFull.data.Duration = this.insuredSumAndPremiumForm.value.insurancePeriod
          this.updateDraftModelFull.data.PremiumRate = this.basicInfoForm.value.premiumRate
          this.updateDraftModelFull.data.PaymentPeriod = 0
          this.updateDraftModelFull.data.RentPaymentFrequency = 0
          this.updateDraftModelFull.data.RentPayment = 0
          this.updateDraftModelFull.data.PaymentFrequency = parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment)
          this.updateDraftModelFull.data.PaymentType = parseInt(this.insuredSumAndPremiumForm.value.methodPayment)
          this.updateDraftModelFull.data.PaymentInCurrency = parseInt(this.insuredSumAndPremiumForm.value.currencyPayment)
          this.updateDraftModelFull.data.PaymentOutCurrency = parseInt(this.insuredSumAndPremiumForm.value.currencyPayout)
          this.updateDraftModelFull.data.UserID = this.userId
          this.updateDraftModelFull.data.NotificationsAgreement = this.checkBoxesForm.value.confirmSMS == '1' ? true : false
          this.updateDraftModelFull.data.Verified = this.checkBoxesForm.value.confirmVeracity
          this.updateDraftModelFull.data.Verified2 = this.checkBoxesForm.value.confirmData
          this.updateDraftModelFull.data.Verified3 = this.checkBoxesForm.value.confirmEmail == '1' ? true : false
          this.updateDraftModelFull.data.Indexation = this.insuredSumAndPremiumForm.value.indexation == '' ? null : this.insuredSumAndPremiumForm.value.indexation == '0' ? false : true

          let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
          let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
          this.updateDraftModelFull.data.InsuranceStart = startDate;
          this.updateDraftModelFull.data.InsuranceEnd = endDate;
          // this.updateDraftModelFull.data.RedemptionAndCapitalization.OfferID = 0;

          if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            this.updateDraftModelFull.data.AdditionalInsuranceType = 0
            // console.log("Personal")
            this.updateDraftModelFull.data.DeathByAccident = this.personalForm.value.deathByAccident;
            this.updateDraftModelFull.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

            this.updateDraftModelFull.data.AdditionalRiderDeath = this.personalForm.value.riderDeath;
            this.updateDraftModelFull.data.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
            this.updateDraftModelFull.data.AdditionalRiderTB = this.personalForm.value.riderTB;
            if (this.personalForm.value.includeMSO == '0') {
              this.updateDraftModelFull.data.IncludeMSO = false;
            } else {
              this.updateDraftModelFull.data.IncludeMSO = true;
            }
            if (this.personalForm.value.includeDNA == '0') {
              this.updateDraftModelFull.data.IncludeDNA = false;
            } else {
              this.updateDraftModelFull.data.IncludeDNA = true;
            }
            if (this.personalForm.value.invalidityByAccident) {
              if (this.personalForm.value.surgery) {
                this.updateDraftModelFull.data.Surgery = this.personalForm.value.surgery;
              } else {
                this.updateDraftModelFull.data.Surgery = null;
              }
              if (this.personalForm.value.monthlyRent) {
                this.updateDraftModelFull.data.MonthlyRent = this.personalForm.value.monthlyRent;
              } else {
                this.updateDraftModelFull.data.MonthlyRent = null;
              }
              if (this.personalForm.value.daylyFee) {
                this.updateDraftModelFull.data.DailyFee = this.personalForm.value.daylyFee;
              } else {
                this.updateDraftModelFull.data.DailyFee = null
              }
              if (this.personalForm.value.treatmanExpenses) {
                this.updateDraftModelFull.data.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
              } else {
                this.updateDraftModelFull.data.TreatmentExpenses = null;
              }
              this.updateDraftModelFull.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
            } else {
              this.updateDraftModelFull.data.InvalidityByAccident = null;
              this.updateDraftModelFull.data.Surgery = null;
              this.updateDraftModelFull.data.MonthlyRent = null;
              this.updateDraftModelFull.data.DailyFee = null;
              this.updateDraftModelFull.data.TreatmentExpenses = null;
              this.updateDraftModelFull.data.IncludeMSO = false;
              this.updateDraftModelFull.data.IncludeDNA = false;
            }
            if (this.personalForm.value.planRadio == '1') {
              this.updateDraftModelFull.data.ProductType = 0;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.personalForm.value.planRadio == '2') {
              this.updateDraftModelFull.data.ProductType = 1;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.updateDraftModelFull.data.ProductType = 2;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            this.updateDraftModelFull.data.AdditionalInsuranceType = this.insuranceCoverageForm.value.incidentRadio;
            // console.log("Dopunsko")
            this.updateDraftModelFull.data.DeathByAccident = this.sentInformations.deathByAccident;
            this.updateDraftModelFull.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
            this.updateDraftModelFull.data.MonthlyRent = this.sentInformations.monthlyRent;
            this.updateDraftModelFull.data.TreatmentExpenses = null;
            this.updateDraftModelFull.data.DailyFee = null;
            switch (this.insuranceCoverageForm.value.incidentRadio) {
              case '1':
                this.updateDraftModelFull.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                this.updateDraftModelFull.data.Surgery = null;
                this.updateDraftModelFull.data.IncludeMSO = false;
                this.updateDraftModelFull.data.IncludeDNA = false;
                break;
              case '2':
                this.updateDraftModelFull.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                this.updateDraftModelFull.data.Surgery = this.sentInformations.surgery;
                this.updateDraftModelFull.data.IncludeMSO = true;
                this.updateDraftModelFull.data.IncludeDNA = false;
                break;
              case '3':
                this.updateDraftModelFull.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                this.updateDraftModelFull.data.Surgery = this.sentInformations.surgery;
                this.updateDraftModelFull.data.DailyFee = this.sentInformations.dailyFee;
                this.updateDraftModelFull.data.IncludeMSO = false;
                this.updateDraftModelFull.data.IncludeDNA = false;
                break;
              case '4':
                this.updateDraftModelFull.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                this.updateDraftModelFull.data.Surgery = null;
                this.updateDraftModelFull.data.IncludeMSO = true;
                this.updateDraftModelFull.data.IncludeDNA = true;
                break;
              default:
                break;
            }
            if (this.insuranceCoverageForm.value.planRadio == '1') {
              this.updateDraftModelFull.data.ProductType = 0;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.insuranceCoverageForm.value.planRadio == '2') {
              this.updateDraftModelFull.data.ProductType = 1;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.updateDraftModelFull.data.ProductType = 2;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          } else {
            this.updateDraftModelFull.data.AdditionalInsuranceType = 5
            this.updateDraftModelFull.data.DeathByAccident = null;
            this.updateDraftModelFull.data.InvalidityByAccident = null;
            this.updateDraftModelFull.data.Surgery = null;
            this.updateDraftModelFull.data.TreatmentExpenses = null;
            this.updateDraftModelFull.data.DailyFee = null;
            this.updateDraftModelFull.data.MonthlyRent = null;
            this.updateDraftModelFull.data.IncludeMSO = false;
            this.updateDraftModelFull.data.IncludeDNA = false;
            this.updateDraftModelFull.data.AdditionalPremiumRate = 0;
            if (this.noCovrageForm.value.planRadio == '1') {
              this.updateDraftModelFull.data.ProductType = 0;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.noCovrageForm.value.planRadio == '2') {
              this.updateDraftModelFull.data.ProductType = 1;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.updateDraftModelFull.data.ProductType = 2;
              this.updateDraftModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.updateDraftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          }
        }

        if (this.insuranceUsers.length > 0)
          this.updateDraftModelFull.data.Beneficiaries = this.insuranceUsers

        if (this.healthForm.value.threeMonthStayAbroad != '')
          if (this.healthForm.value.threeMonthStayAbroad == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q1Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q1Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q1Description = this.healthForm.value.threeMonthStayAbroadDescription
        if (this.healthForm.value.deniedAcceptedRequest != '')
          if (this.healthForm.value.deniedAcceptedRequest == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q2Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q2Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q2Description = this.healthForm.value.deniedacceptedRequestDescription
        if (this.healthForm.value.sportActivity != '')
          if (this.healthForm.value.sportActivity == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q3Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q3Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q3Description = this.healthForm.value.sportActivityDescription
        if (this.healthForm.value.constantDoctorTreats != '')
          if (this.healthForm.value.constantDoctorTreats == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q4Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q4Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q4Description = this.healthForm.value.constantDoctorTreatsDescription
        if (this.healthForm.value.specialMedicalExamination != '')
          if (this.healthForm.value.specialMedicalExamination == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q5Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q5Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q5Description = this.healthForm.value.specialMedicalExaminationDescription
        if (this.healthForm.value.takingMedicines != '')
          if (this.healthForm.value.takingMedicines == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q6Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q6Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q6Description = this.healthForm.value.takingMedicinesDescription
        if (this.healthForm.value.alcoholOrIntoxicants != '')
          if (this.healthForm.value.alcoholOrIntoxicants == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q7Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q7Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q7Description = this.healthForm.value.alcoholOrIntoxicantsDescription
        if (this.healthForm.value.helpForAlcoholAddiction != '')
          if (this.healthForm.value.helpForAlcoholAddiction == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q8Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q8Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q8Description = this.healthForm.value.helpForAlcoholAddictionDescription
        if (this.healthForm.value.consumeCigarettes != '')
          if (this.healthForm.value.consumeCigarettes == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q9Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q9Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q9Description = this.healthForm.value.consumeCigarettesDescription
        if (this.healthForm.value.seriousIllness != '')
          if (this.healthForm.value.seriousIllness == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q10Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q10Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q10Description = this.healthForm.value.seriousIllnessDescription
        if (this.healthForm.value.dangerAtWork != '')
          if (this.healthForm.value.dangerAtWork == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q11Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q11Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q11Description = this.healthForm.value.dangerAtWorkDescription
        if (this.healthForm.value.tenYearMedicalTests != '')
          if (this.healthForm.value.tenYearMedicalTests == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q12Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q12Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q12Description = this.healthForm.value.tenYearmedicalTestsDescription
        if (this.healthForm.value.thirtyDaysIncapable != '')
          if (this.healthForm.value.thirtyDaysIncapable == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q13Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q13Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q13Description = this.healthForm.value.thirtyDaysIncapableDescription
        if (this.healthForm.value.levelOfInvaliditet != '')
          if (this.healthForm.value.levelOfInvaliditet == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q14Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q14Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q14Description = this.healthForm.value.levelOfInvaliditetDescription

        if (this.healthForm.value.newFifteenthQuestion != '')
          if (this.healthForm.value.newFifteenthQuestion == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q15Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q15Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q15Description = this.healthForm.value.newFifteenthQuestionDescription

        this.updateDraftModelFull.data.HealthQuestionnaire.Q16Answer = this.healthForm.value.nameOfDoctor

        if (this.healthForm.value.familySickness != '')
          if (this.healthForm.value.familySickness == '0')
            this.updateDraftModelFull.data.HealthQuestionnaire.Q17Answer = true
          else
            this.updateDraftModelFull.data.HealthQuestionnaire.Q17Answer = false
        this.updateDraftModelFull.data.HealthQuestionnaire.Q17Description = this.healthForm.value.familySicknessDescription

        this.updateDraftModelFull.data.HealthQuestionnaire.Agreement = this.healthForm.value.agreeToHealthQuestionnaire

        if (this.basicInfo.data.contractorType == '1') {
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q1NP = false;
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q2NP = false;
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
        } else {
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q1LE = false;
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q2LE = false;
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q3LE = false;
          this.updateDraftModelFull.data.FATCAQuestionnaire.Q4LE = false;
        }

        if (this.spnftForm.value.firstname)
          this.updateDraftModelFull.data.SPNFTForm.Firstname = this.spnftForm.value.firstname.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.Firstname = ''
        if (this.spnftForm.value.lastname)
          this.updateDraftModelFull.data.SPNFTForm.Lastname = this.spnftForm.value.lastname.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.Lastname = ''
        if (this.spnftForm.value.companyName)
          this.updateDraftModelFull.data.SPNFTForm.CompanyName = this.spnftForm.value.companyName.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.CompanyName = ''
        // if (this.spnftForm.value.companyName)
        //   this.updateDraftModelFull.data.SPNFTForm.CompanyName = this.spnftForm.value.companyName
        // else
        //   this.updateDraftModelFull.data.SPNFTForm.CompanyName = ''
        if (this.spnftForm.value.jmbg)
          this.updateDraftModelFull.data.SPNFTForm.JMBG = this.spnftForm.value.jmbg
        else
          this.updateDraftModelFull.data.SPNFTForm.JMBG = ''
        if (this.spnftForm.value.settlementob)
          this.updateDraftModelFull.data.SPNFTForm.PlaceOfBirth = this.spnftForm.value.settlementob.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.PlaceOfBirth = ''
        if (this.spnftForm.value.address)
          this.updateDraftModelFull.data.SPNFTForm.Address = this.spnftForm.value.address.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.Address = ''
        if (this.spnftForm.value.postalCode)
          this.updateDraftModelFull.data.SPNFTForm.PostalCode = this.spnftForm.value.postalCode
        else
          this.updateDraftModelFull.data.SPNFTForm.PostalCode = ''
        if (this.spnftForm.value.settlement)
          this.updateDraftModelFull.data.SPNFTForm.Settlement = this.spnftForm.value.settlement.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.Settlement = ''
        if (this.spnftForm.value.citizenship)
          this.updateDraftModelFull.data.SPNFTForm.Citizenship = this.spnftForm.value.citizenship.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.Citizenship = ''
        if (this.spnftForm.value.legalRepresentativeFirstname)
          this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeFirtsname = this.spnftForm.value.legalRepresentativeFirstname.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeFirtsname = ''
        if (this.spnftForm.value.legalRepresentativeLastname)
          this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeLastname = this.spnftForm.value.legalRepresentativeLastname.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeLastname = ''
        if (this.spnftForm.value.representativeJmbg)
          this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeJMBG = this.spnftForm.value.representativeJmbg
        else
          this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeJMBG = ''
        if (this.spnftForm.value.pib)
          this.updateDraftModelFull.data.SPNFTForm.TaxID = this.spnftForm.value.pib
        else
          this.updateDraftModelFull.data.SPNFTForm.TaxID = ''
        if (this.spnftForm.value.mb)
          this.updateDraftModelFull.data.SPNFTForm.CompanyID = this.spnftForm.value.mb
        else
          this.updateDraftModelFull.data.SPNFTForm.CompanyID = ''
        if (this.spnftForm.value.typeOfDocument)
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentType = this.spnftForm.value.typeOfDocument
        else
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentType = ''
        if (this.spnftForm.value.numberOfDocument)
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentNumber = this.spnftForm.value.numberOfDocument
        else
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentNumber = ''
        if (this.spnftForm.value.dateOfIssuringDocument)
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0]
        else
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = ''
        if (this.spnftForm.value.personalDocumentExpirationDate)
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0]
        else
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = ''
        if (this.spnftForm.value.placeOfIssuringDocument)
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedPlace = this.spnftForm.value.placeOfIssuringDocument.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedPlace = ''
        if (this.spnftForm.value.officialCloseFamily == 0)
          this.updateDraftModelFull.data.SPNFTForm.IsPoliticianOrCloseAssociate = false
        else
          this.updateDraftModelFull.data.SPNFTForm.IsPoliticianOrCloseAssociate = true
        if (this.spnftForm.value.officialCloseFamily == 1)
          this.updateDraftModelFull.data.SPNFTForm.InOffice = this.spnftForm.value.officialPeriod
        else
          this.updateDraftModelFull.data.SPNFTForm.InOffice = ''
        if (this.spnftForm.value.officialCloseFamily == 1)
          this.updateDraftModelFull.data.SPNFTForm.RemarkIfYes = this.spnftForm.value.closeFamilyName
        else
          this.updateDraftModelFull.data.SPNFTForm.RemarkIfYes = ''
        if (this.spnftForm.value.cutomerAnotherPerson == '')
          this.updateDraftModelFull.data.SPNFTForm.ClientAppliesThroughIntermediary = null
        else
          if (this.spnftForm.value.cutomerAnotherPerson == '1')
            this.updateDraftModelFull.data.SPNFTForm.ClientAppliesThroughIntermediary = true
          else
            this.updateDraftModelFull.data.SPNFTForm.ClientAppliesThroughIntermediary = false
        if (this.spnftForm.value.cutomerAnotherPersonRole)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryType = this.spnftForm.value.cutomerAnotherPersonRole
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryType = null
        if (this.spnftForm.value.firstnameOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryFirstname = this.spnftForm.value.firstnameOnBehalf.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryFirstname = ''
        if (this.spnftForm.value.lastnameOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryLastname = this.spnftForm.value.lastnameOnBehalf.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryLastname = ''
        if (this.spnftForm.value.jmbgOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryJMBG = this.spnftForm.value.jmbgOnBehalf
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryJMBG = ''
        if (this.spnftForm.get('dob').value)
          this.updateDraftModelFull.data.SPNFTForm.DateOfBirth = this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0]
        else
          this.updateDraftModelFull.data.SPNFTForm.DateOfBirth = ''
        if (this.spnftForm.get('dobOnBehalf').value)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryDateOfBirth = this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0]
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryDateOfBirth = ''
        if (this.spnftForm.value.settlementobOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPlaceOfBirth = this.spnftForm.value.settlementobOnBehalf.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPlaceOfBirth = ''
        if (this.spnftForm.value.addressOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryAddress = this.spnftForm.value.addressOnBehalf.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryAddress = ''
        if (this.spnftForm.value.postalCodeOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPostalCode = this.spnftForm.value.postalCodeOnBehalf
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPostalCode = ''
        if (this.spnftForm.value.settlementOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediarySettlement = this.spnftForm.value.settlementOnBehalf.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediarySettlement = ''
        if (this.spnftForm.value.idTypeOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentType = this.spnftForm.value.idTypeOnBehalf
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentType = ''
        if (this.spnftForm.value.idNumberOnBehalf)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentNumber = this.spnftForm.value.idNumberOnBehalf
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentNumber = ''
        if (this.spnftForm.value.idDate)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0]
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = ''
        if (this.spnftForm.value.idPlace)
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedPlace = this.spnftForm.value.idPlace.toUpperCase()
        else
          this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedPlace = ''
        if (this.spnftForm.value.purposeOfBusinessRelation != '')
          this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurpose = this.spnftForm.value.purposeOfBusinessRelation
        else
          this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurpose = null
        if (this.spnftForm.value.purposeOfBusinessRelation == '3')
          this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurposeOther = this.spnftForm.value.purposeOfBusinessRelationOther
        else
          this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurposeOther = ''
        if (this.spnftForm.value.originOfProperty != '')
          this.updateDraftModelFull.data.SPNFTForm.PropertyOrigin = this.spnftForm.value.originOfProperty
        else
          this.updateDraftModelFull.data.SPNFTForm.PropertyOrigin = null
        if (this.spnftForm.value.originOfProperty == '3')
          this.updateDraftModelFull.data.SPNFTForm.PropertyOriginOther = this.spnftForm.value.originOfPropertyOther
        else
          this.updateDraftModelFull.data.SPNFTForm.PropertyOriginOther = ''


        if (this.platimatikForm.value.firstname)
          this.updateDraftModelFull.data.PlatimatikForm.Firstname = this.platimatikForm.value.firstname.toUpperCase()
        else
          this.updateDraftModelFull.data.PlatimatikForm.Firstname = ''
        if (this.platimatikForm.value.lastname)
          this.updateDraftModelFull.data.PlatimatikForm.Lastname = this.platimatikForm.value.lastname.toUpperCase()
        else
          this.updateDraftModelFull.data.PlatimatikForm.Lastname = ''
        if (this.platimatikForm.value.address)
          this.updateDraftModelFull.data.PlatimatikForm.Address = this.platimatikForm.value.address.toUpperCase()
        else
          this.updateDraftModelFull.data.PlatimatikForm.Address = ''
        if (this.platimatikForm.value.postalCode)
          this.updateDraftModelFull.data.PlatimatikForm.PostalCode = this.platimatikForm.value.postalCode
        else
          this.updateDraftModelFull.data.PlatimatikForm.PostalCode = ''
        if (this.platimatikForm.value.placeOfResidence)
          this.updateDraftModelFull.data.PlatimatikForm.Settlement = this.platimatikForm.value.placeOfResidence.toUpperCase()
        else
          this.updateDraftModelFull.data.PlatimatikForm.Settlement = ''
        if (this.platimatikForm.value.jmbg)
          this.updateDraftModelFull.data.PlatimatikForm.JMBG = this.platimatikForm.value.jmbg
        else
          this.updateDraftModelFull.data.PlatimatikForm.JMBG = ''
        if (this.platimatikForm.value.bankName)
          this.updateDraftModelFull.data.PlatimatikForm.Bank = this.platimatikForm.value.bankName
        else
          this.updateDraftModelFull.data.PlatimatikForm.Bank = ''
        this.updateDraftModelFull.data.PlatimatikForm.AccountNumber = this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber
        if (this.platimatikForm.value.bankBic)
          this.updateDraftModelFull.data.PlatimatikForm.BIC = this.platimatikForm.value.bankBic
        else
          this.updateDraftModelFull.data.PlatimatikForm.BIC = ''
        this.updateDraftModelFull.data.PlatimatikForm.ContractNumber = ''
        this.updateDraftModelFull.data.PlatimatikForm.Currency = 1
        if (this.platimatikForm.get('validityFirstTermFrom').value)
          this.updateDraftModelFull.data.PlatimatikForm.FirstMandateFrom = this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0]
        else
          this.updateDraftModelFull.data.PlatimatikForm.FirstMandateFrom = ''
        if (this.platimatikForm.get('validityFirstTermTo').value)
          this.updateDraftModelFull.data.PlatimatikForm.FirstMandateTo = this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0]
        else
          this.updateDraftModelFull.data.PlatimatikForm.FirstMandateTo = ''
        if (this.platimatikForm.get('validitySecondTermFrom').value)
          this.updateDraftModelFull.data.PlatimatikForm.SecondMandateFrom = this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0]
        else
          this.updateDraftModelFull.data.PlatimatikForm.SecondMandateFrom = ''
        if (this.platimatikForm.get('validitySecondTermTo').value)
          this.updateDraftModelFull.data.PlatimatikForm.SecondMandateTo = this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0]
        else
          this.updateDraftModelFull.data.PlatimatikForm.SecondMandateTo = ''

        console.log(this.updateDraftModelFull)
        this.offerService.editDraftOffer(this.updateDraftModelFull)
          .then(
            x => {
              if (draftTo == 0) {
                this.successTitle = "Uspešno ste sačuvali promene";
                this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
              } else if (draftTo == 1) {
                this.offerService.createFromDraftOffer(this.offerId)
                  .then(
                    x => {
                      this.riskAssessmentForm.reset();
                      this.modalService.open(this.riskFormModal, { size: 'xl', backdrop: 'static', keyboard: false })
                      if (this.spnftForm.value.officialCloseFamily == '1') {
                        this.riskAssessmentForm.get('question11').setValue('0');
                        this.riskAssessmentForm.get('question11').disable();
                      } else {
                        this.riskAssessmentForm.get('question11').enable();
                      }
                    },
                    (x: any) => {
                      console.log(x)
                      this.errorTitle = x.error;
                      this.modalService.open(this.alertModal, { centered: true })
                    }
                  )
              } else if (draftTo == 2) {
                this.offerService.createFromDraftOffer(this.offerId)
                  .then(
                    x => {
                      this.offerService.sendLocalDocuments(this.offerId)
                        .then(
                          x => {
                            this.modalService.dismissAll();
                            this.resetAllForms()
                            this.insuranceUsers = []
                            this.formPlatimatikBool = false;
                            this.formSpnftBool = false;
                            this.noticeFatcaBool = false;
                            this.healthQuestionnaireBool = false;
                            this.calculcatorUsersBool = false;
                            this.validInsuranceAndSumPremium = false;
                            this.validUser = false;
                            this.validSPNFT = false;
                            this.validPLATIMATIK = false;
                            this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                            // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
                          }
                        )
                    },
                    (x: any) => {
                      console.log(x)
                      this.errorTitle = x.error;
                      this.modalService.open(this.alertModal, { centered: true })
                    }
                  )
              }

            },
            e => console.log(e)
          )
      }
    }
  }


  validInsuranceAndSumPremium: Boolean = false;
  validUser: Boolean = false;
  validSPNFT: Boolean = true;
  validPLATIMATIK: Boolean = false;
  userValue;
  offerModelFull: StandardOSOffer;
  saveDigital() {
    // console.log(this.hideExport)
    // console.log(this.basicInfo.data)
    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }
    // if (userValue) {
    //   console.log("Fali jedna rola!")
    // } else {
    //   console.log("Sve role su tu!")
    // }


    this.offerModelFull = new StandardOSOffer({
      InsuranceStart: '',
      InsuranceEnd: '',
      OfferNumber: "",
      OfferType: 1,
      ContractorID: 0,
      InsureeID: 0,
      OneTimePayment: false,
      PaymentPeriodMonths: 0,
      Interest: 0,
      CreditAmount: 0,
      AdditionalIL: false,
      AdditionalBF: false,
      AdditionalAS: false,
      Contractor: new OfferClient(
        this.basicInfo.data.contractorType == '1' ? '1' : '0',
        this.basicInfo.data.contractorFirstname,
        this.basicInfo.data.contractorLastname,
        this.basicInfo.data.contractorResponsibleName,
        this.basicInfo.data.contractorJMBG,
        this.basicInfo.data.contractorPhonenumber,
        this.basicInfo.data.contractorEmail,
        this.basicInfo.data.contractorAddress,
        this.basicInfo.data.contractorSettlement,
        this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode.toString() : "",
        this.basicInfo.data.contractorAddressOfDelivery,
        this.basicInfo.data.contractorSettlementOfDelivery,
        this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery.toString() : "",
        0,
        "",
        ""
      ),
      Insuree: new OfferInsuree(
        this.basicInfo.data.insuredFirstname,
        this.basicInfo.data.insuredLastname,
        this.basicInfo.data.insuredJMBG,
        this.basicInfo.data.insuredDOB,
        this.basicInfo.data.insuredMobile,
        this.basicInfo.data.insuredEmail,
        this.basicInfo.data.insuredAddress,
        this.basicInfo.data.insuredSettlement,
        this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode.toString() : "",
        this.basicInfo.data.insuredJob,
        0,
        0
      ),
      Gender: this.insuredSumAndPremiumForm.value.gender,
      ContractorIsInsuree: this.basicInfo.data.contractorCopy,
      HazardLevel: 2,
      CigarettesPerDay: this.insuredSumAndPremiumForm.value.cigarettesDaily,
      Height: this.insuredSumAndPremiumForm.value.height,
      Weight: this.insuredSumAndPremiumForm.value.weight,
      AdditionalInsuranceDeath: false,
      PaymentPeriodOut: 0,
      PaymentPeriodIn: 0,
      StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
      Duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
      PremiumRate: this.basicInfoForm.value.premiumRate,
      PaymentPeriod: 0,
      RentPaymentFrequency: 0,
      RentPayment: 0,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      PaymentType: parseInt(this.insuredSumAndPremiumForm.value.methodPayment),
      ClientStatusID: null,
      PaymentInCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayment),
      PaymentOutCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayout),
      Comment: "",
      UserID: this.userId,
      NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
      Verified: this.checkBoxesForm.value.confirmVeracity,
      Verified2: this.checkBoxesForm.value.confirmData,
      Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false,
      Beneficiaries: this.insuranceUsers,
      RedemptionAndCapitalization: new RedemptionAndCapitalizations(),
      HealthQuestionnaire: new HealthQuestionnaire(
        0,
        this.healthForm.value.threeMonthStayAbroad == '0' ? true : false,
        this.healthForm.value.threeMonthStayAbroad == '0' ? this.healthForm.value.threeMonthStayAbroadDescription : '',
        this.healthForm.value.deniedAcceptedRequest == '0' ? true : false,
        this.healthForm.value.deniedAcceptedRequest == '0' ? this.healthForm.value.deniedacceptedRequestDescription : '',
        this.healthForm.value.sportActivity == '0' ? true : false,
        this.healthForm.value.sportActivity == '0' ? this.healthForm.value.sportActivityDescription : '',
        this.healthForm.value.constantDoctorTreats == '0' ? true : false,
        this.healthForm.value.constantDoctorTreats == '0' ? this.healthForm.value.constantDoctorTreatsDescription : '',
        this.healthForm.value.specialMedicalExamination == '0' ? true : false,
        this.healthForm.value.specialMedicalExamination == '0' ? this.healthForm.value.specialMedicalExaminationDescription : '',
        this.healthForm.value.takingMedicines == '0' ? true : false,
        this.healthForm.value.takingMedicines == '0' ? this.healthForm.value.takingMedicinesDescription : '',
        this.healthForm.value.alcoholOrIntoxicants == '0' ? true : false,
        this.healthForm.value.alcoholOrIntoxicants == '0' ? this.healthForm.value.alcoholOrIntoxicantsDescription : '',
        this.healthForm.value.helpForAlcoholAddiction == '0' ? true : false,
        this.healthForm.value.helpForAlcoholAddiction == '0' ? this.healthForm.value.helpForAlcoholAddictionDescription : '',
        this.healthForm.value.consumeCigarettes == '0' ? true : false,
        this.healthForm.value.consumeCigarettes == '0' ? this.healthForm.value.consumeCigarettesDescription : '',
        this.healthForm.value.seriousIllness == '0' ? true : false,
        this.healthForm.value.seriousIllness == '0' ? this.healthForm.value.seriousIllnessDescription : '',
        this.healthForm.value.dangerAtWork == '0' ? true : false,
        this.healthForm.value.dangerAtWork == '0' ? this.healthForm.value.dangerAtWorkDescription : '',
        this.healthForm.value.tenYearMedicalTests == '0' ? true : false,
        this.healthForm.value.tenYearMedicalTests == '0' ? this.healthForm.value.tenYearmedicalTestsDescription : '',
        this.healthForm.value.thirtyDaysIncapable == '0' ? true : false,
        this.healthForm.value.thirtyDaysIncapable == '0' ? this.healthForm.value.thirtyDaysIncapableDescription : '',
        this.healthForm.value.levelOfInvaliditet == '0' ? true : false,
        this.healthForm.value.levelOfInvaliditet == '0' ? this.healthForm.value.levelOfInvaliditetDescription : '',
        this.healthForm.value.newFifteenthQuestion == '0' ? true : this.healthForm.value.newFifteenthQuestion == '1' ? false : null,
        this.healthForm.value.newFifteenthQuestion == '0' ? this.healthForm.value.newFifteenthQuestionDescription : '',
        this.healthForm.value.nameOfDoctor,
        this.healthForm.value.familySickness == '0' ? true : this.healthForm.value.familySickness == '1' ? false : null,
        this.healthForm.value.familySickness == '0' ? this.healthForm.value.familySicknessDescription : '',
        this.healthForm.value.agreeToHealthQuestionnaire
      ),
      FATCAQuestionnaire: new FATCAQuestionnaire(
        0
      ),
      SPNFTForm: new SPNFTQuestionnaire(
        0,
        this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
        this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
        this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
        this.spnftForm.value.jmbg,
        '',
        this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
        this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
        this.spnftForm.value.postalCode ? this.spnftForm.value.postalCode.toString() : "",
        this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
        this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
        this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
        this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
        this.spnftForm.value.representativeJmbg,
        this.spnftForm.value.pib,
        this.spnftForm.value.mb,
        this.spnftForm.value.typeOfDocument,
        this.spnftForm.value.numberOfDocument,
        this.spnftForm.value.dateOfIssuringDocument ? this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0] : '',
        this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
        this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
        this.spnftForm.value.officialCloseFamily == 0 ? false : true,
        this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
        this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
        !this.spnftForm.value.cutomerAnotherPerson ? false : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
        this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
        this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
        this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
        this.spnftForm.value.jmbgOnBehalf,
        '',
        this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
        this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
        this.spnftForm.value.postalCodeOnBehalf ? this.spnftForm.value.postalCodeOnBehalf.toString() : "",
        this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
        this.spnftForm.value.idTypeOnBehalf,
        this.spnftForm.value.idNumberOnBehalf,
        '',
        this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
        this.spnftForm.value.purposeOfBusinessRelation,
        this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
        this.spnftForm.value.originOfProperty,
        this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
      ),
      PlatimatikForm: new PLATIMATICQuestionnaire(
        0,
        this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
        this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
        this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
        this.platimatikForm.value.postalCode ? this.platimatikForm.value.postalCode.toString() : "",
        this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
        this.platimatikForm.value.jmbg,
        this.platimatikForm.value.bankName,
        this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
        this.platimatikForm.value.bankBic,
        '',
        1,
        this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
        this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
        this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
        this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : ''
      )
    })
    if (this.spnftForm.get('dobOnBehalf').value) {
      this.offerModelFull.data.SPNFTForm.IntermediaryDateOfBirth = this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.IntermediaryDateOfBirth = ''
    }
    if (this.spnftForm.get('dob').value) {
      this.offerModelFull.data.SPNFTForm.DateOfBirth = this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.DateOfBirth = ''
    }
    if (this.spnftForm.value.dateOfIssuringDocument) {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = ''
    }
    if (this.spnftForm.value.personalDocumentExpirationDate) {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = ''
    }
    if (this.spnftForm.value.idDate) {
      this.offerModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = ''
    }
    if (this.basicInfo.data.contractorType == '1') {
      this.offerModelFull.data.Contractor.TaxID = this.basicInfo.data.contractorPIB;
      this.offerModelFull.data.Contractor.CompanyID = this.basicInfo.data.contractorID;
      this.offerModelFull.data.Contractor.ClientType = '1';
      this.offerModelFull.data.FATCAQuestionnaire.Q1NP = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q2NP = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
    } else {
      this.offerModelFull.data.Contractor.TaxID = '';
      this.offerModelFull.data.Contractor.CompanyID = '';
      this.offerModelFull.data.Contractor.ClientType = '0';
      this.offerModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q1LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q2LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q3LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q4LE = false;
    }
    if (this.insuredSumAndPremiumForm.value.indexation == '0') {
      this.offerModelFull.data.Indexation = false;
    } else if (this.insuredSumAndPremiumForm.value.indexation == '1') {
      this.offerModelFull.data.Indexation = true;
    }



    let helthBool = false;
    if (
      !this.healthForm.value.threeMonthStayAbroad ||
      (this.healthForm.value.threeMonthStayAbroad == '0' && !this.healthForm.value.threeMonthStayAbroadDescription) ||
      !this.healthForm.value.deniedAcceptedRequest ||
      (this.healthForm.value.deniedAcceptedRequest == '0' && !this.healthForm.value.deniedacceptedRequestDescription) ||
      !this.healthForm.value.sportActivity ||
      (this.healthForm.value.sportActivity == '0' && !this.healthForm.value.sportActivityDescription) ||
      !this.healthForm.value.constantDoctorTreats ||
      (this.healthForm.value.constantDoctorTreats == '0' && !this.healthForm.value.constantDoctorTreatsDescription) ||
      !this.healthForm.value.specialMedicalExamination ||
      (this.healthForm.value.specialMedicalExamination == '0' && !this.healthForm.value.specialMedicalExaminationDescription) ||
      !this.healthForm.value.takingMedicines ||
      (this.healthForm.value.takingMedicines == '0' && !this.healthForm.value.takingMedicinesDescription) ||
      !this.healthForm.value.alcoholOrIntoxicants ||
      (this.healthForm.value.alcoholOrIntoxicants == '0' && !this.healthForm.value.alcoholOrIntoxicantsDescription) ||
      !this.healthForm.value.helpForAlcoholAddiction ||
      (this.healthForm.value.helpForAlcoholAddiction == '0' && !this.healthForm.value.helpForAlcoholAddictionDescription) ||
      !this.healthForm.value.consumeCigarettes ||
      (this.healthForm.value.consumeCigarettes == '0' && !this.healthForm.value.consumeCigarettesDescription) ||
      !this.healthForm.value.seriousIllness ||
      (this.healthForm.value.seriousIllness == '0' && !this.healthForm.value.seriousIllnessDescription) ||
      !this.healthForm.value.dangerAtWork ||
      (this.healthForm.value.dangerAtWork == '0' && !this.healthForm.value.dangerAtWorkDescription) ||
      !this.healthForm.value.tenYearMedicalTests ||
      (this.healthForm.value.tenYearMedicalTests == '0' && !this.healthForm.value.tenYearmedicalTestsDescription) ||
      !this.healthForm.value.thirtyDaysIncapable ||
      (this.healthForm.value.thirtyDaysIncapable == '0' && !this.healthForm.value.thirtyDaysIncapableDescription) ||
      !this.healthForm.value.levelOfInvaliditet ||
      (this.healthForm.value.levelOfInvaliditet == '0' && !this.healthForm.value.levelOfInvaliditetDescription) ||
      !this.healthForm.value.newFifteenthQuestion ||
      (this.healthForm.value.newFifteenthQuestion == '0' && !this.healthForm.value.newFifteenthQuestionDescription) ||
      !this.healthForm.value.nameOfDoctor ||
      // (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && !this.healthForm.value.familySickness) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription)) ||
      !this.healthForm.value.agreeToHealthQuestionnaire
    ) {
      helthBool = true;
    } else {
      helthBool = false;
    }

    if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      if ((this.personalForm.value.planRadio == '2' || this.personalForm.value.planRadio == '3') && !this.healthForm.value.familySickness) {
        helthBool = true;
      }

    } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      if ((this.insuranceCoverageForm.value.planRadio == '2' || this.insuranceCoverageForm.value.planRadio == '3') && !this.healthForm.value.familySickness) {
        helthBool = true;
      }
    } else {
      if ((this.noCovrageForm.value.planRadio == '2' || this.noCovrageForm.value.planRadio == '3') && !this.healthForm.value.familySickness) {
        helthBool = true;
      }
    }

    if (
      (this.healthForm.value.consumeCigarettes == '0' && this.insuredSumAndPremiumForm.value.cigarettesDaily == 0) ||
      (this.healthForm.value.consumeCigarettes == '1' && this.insuredSumAndPremiumForm.value.cigarettesDaily > 0)
    ) {
      this.errorTitle = "Odgovor na ponudi u vezi cigareta nije usklađen sa upitnikom. Molimo ispravite odgovor na ponudi.";
      this.modalService.open(this.alertModal, { centered: true })
      return;
    }

    // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber.toString()))
    // console.log(offer)
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.userSignature) {
        this.errorTitle = "Nemate potpis";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (
          ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
        ) {
          this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
          let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
          this.offerModelFull.data.InsuranceStart = startDate;
          this.offerModelFull.data.InsuranceEnd = endDate;
          this.offerModelFull.data.RedemptionAndCapitalization.OfferID = 0;

          // console.log(JSON.stringify(this.sentInformations.standardTable))
          if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            // console.log("Personal")
            this.offerModelFull.data.AdditionalInsuranceType = 0;
            this.offerModelFull.data.DeathByAccident = this.personalForm.value.deathByAccident;
            this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

            this.offerModelFull.data.AdditionalRiderDeath = this.personalForm.value.riderDeath;
            this.offerModelFull.data.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
            this.offerModelFull.data.AdditionalRiderTB = this.personalForm.value.riderTB;
            if (this.personalForm.value.includeMSO == '0') {
              this.offerModelFull.data.IncludeMSO = false;
            } else {
              this.offerModelFull.data.IncludeMSO = true;
            }
            if (this.personalForm.value.includeDNA == '0') {
              this.offerModelFull.data.IncludeDNA = false;
            } else {
              this.offerModelFull.data.IncludeDNA = true;
            }
            if (this.personalForm.value.invalidityByAccident) {
              if (this.personalForm.value.surgery) {
                this.offerModelFull.data.Surgery = this.personalForm.value.surgery;
              } else {
                this.offerModelFull.data.Surgery = null;
              }
              if (this.personalForm.value.monthlyRent) {
                this.offerModelFull.data.MonthlyRent = this.personalForm.value.monthlyRent;
              } else {
                this.offerModelFull.data.MonthlyRent = null;
              }
              if (this.personalForm.value.daylyFee) {
                this.offerModelFull.data.DailyFee = this.personalForm.value.daylyFee;
              } else {
                this.offerModelFull.data.DailyFee = null
              }
              if (this.personalForm.value.treatmanExpenses) {
                this.offerModelFull.data.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
              } else {
                this.offerModelFull.data.TreatmentExpenses = null;
              }
              this.offerModelFull.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
            } else {
              this.offerModelFull.data.InvalidityByAccident = null;
              this.offerModelFull.data.Surgery = null;
              this.offerModelFull.data.MonthlyRent = null;
              this.offerModelFull.data.DailyFee = null;
              this.offerModelFull.data.TreatmentExpenses = null;
              this.offerModelFull.data.IncludeMSO = false;
              this.offerModelFull.data.IncludeDNA = false;
            }
            if (this.personalForm.value.planRadio == '1') {
              this.offerModelFull.data.ProductType = 0;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.personalForm.value.planRadio == '2') {
              this.offerModelFull.data.ProductType = 1;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.offerModelFull.data.ProductType = 2;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
            // console.log("Dopunsko")
            this.offerModelFull.data.AdditionalInsuranceType = this.insuranceCoverageForm.value.incidentRadio;
            this.offerModelFull.data.DeathByAccident = this.sentInformations.deathByAccident;
            this.offerModelFull.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
            this.offerModelFull.data.MonthlyRent = this.sentInformations.monthlyRent;
            this.offerModelFull.data.TreatmentExpenses = null;
            this.offerModelFull.data.DailyFee = null;
            switch (this.insuranceCoverageForm.value.incidentRadio) {
              case '1':
                this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                this.offerModelFull.data.Surgery = null;
                this.offerModelFull.data.IncludeMSO = false;
                this.offerModelFull.data.IncludeDNA = false;
                break;
              case '2':
                this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                this.offerModelFull.data.Surgery = this.sentInformations.surgery;
                this.offerModelFull.data.IncludeMSO = true;
                this.offerModelFull.data.IncludeDNA = false;
                break;
              case '3':
                this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                this.offerModelFull.data.Surgery = this.sentInformations.surgery;
                this.offerModelFull.data.DailyFee = this.sentInformations.dailyFee;
                this.offerModelFull.data.IncludeMSO = false;
                this.offerModelFull.data.IncludeDNA = false;
                break;
              case '4':
                this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                this.offerModelFull.data.Surgery = null;
                this.offerModelFull.data.IncludeMSO = true;
                this.offerModelFull.data.IncludeDNA = true;
                break;
              default:
                break;
            }
            if (this.insuranceCoverageForm.value.planRadio == '1') {
              this.offerModelFull.data.ProductType = 0;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.insuranceCoverageForm.value.planRadio == '2') {
              this.offerModelFull.data.ProductType = 1;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.offerModelFull.data.ProductType = 2;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          } else {
            this.offerModelFull.data.AdditionalInsuranceType = 5;
            this.offerModelFull.data.DeathByAccident = null;
            this.offerModelFull.data.InvalidityByAccident = null;
            this.offerModelFull.data.Surgery = null;
            this.offerModelFull.data.TreatmentExpenses = null;
            this.offerModelFull.data.DailyFee = null;
            this.offerModelFull.data.MonthlyRent = null;
            this.offerModelFull.data.IncludeMSO = false;
            this.offerModelFull.data.IncludeDNA = false;
            this.offerModelFull.data.AdditionalPremiumRate = 0;
            if (this.noCovrageForm.value.planRadio == '1') {
              this.offerModelFull.data.ProductType = 0;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsured
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
            } else if (this.noCovrageForm.value.planRadio == '2') {
              this.offerModelFull.data.ProductType = 1;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsuredPlus
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardPlusTable)
            } else {
              this.offerModelFull.data.ProductType = 2;
              this.offerModelFull.data.SumInsured = this.sentInformations.sumInsuredPro
              this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardProTable)
            }
          }

          let mobileRegex = new RegExp('0[0-9]{7,9}')
          let postalCodeRegex = new RegExp('[0-9]{5}')
          // let emailRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/g
          let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
          // console.log(this.basicInfo.data.insuredEmail.toString())
          // console.log(emailRegex.test(this.basicInfo.data.insuredEmail.toString()))
          if (this.basicInfo.data.contractorType == '1') {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber))
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
              // console.log("Prosle basic")
              // console.log(this.basicInfo)
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                // console.log('prosole insured')
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  // console.log("Prosle currency")
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    // console.log("Prosli korisnici")
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      // console.log("Prosao zdravstveni")
                      if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname ||
                          !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          console.log("Prosao spnft")
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              console.log("Prosao platiomatik")
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }


  draftToDigital() {
    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }

    let helthBool = false;
    if (
      !this.healthForm.value.threeMonthStayAbroad ||
      (this.healthForm.value.threeMonthStayAbroad == '0' && !this.healthForm.value.threeMonthStayAbroadDescription) ||
      !this.healthForm.value.deniedAcceptedRequest ||
      (this.healthForm.value.deniedAcceptedRequest == '0' && !this.healthForm.value.deniedacceptedRequestDescription) ||
      !this.healthForm.value.sportActivity ||
      (this.healthForm.value.sportActivity == '0' && !this.healthForm.value.sportActivityDescription) ||
      !this.healthForm.value.constantDoctorTreats ||
      (this.healthForm.value.constantDoctorTreats == '0' && !this.healthForm.value.constantDoctorTreatsDescription) ||
      !this.healthForm.value.specialMedicalExamination ||
      (this.healthForm.value.specialMedicalExamination == '0' && !this.healthForm.value.specialMedicalExaminationDescription) ||
      !this.healthForm.value.takingMedicines ||
      (this.healthForm.value.takingMedicines == '0' && !this.healthForm.value.takingMedicinesDescription) ||
      !this.healthForm.value.alcoholOrIntoxicants ||
      (this.healthForm.value.alcoholOrIntoxicants == '0' && !this.healthForm.value.alcoholOrIntoxicantsDescription) ||
      !this.healthForm.value.helpForAlcoholAddiction ||
      (this.healthForm.value.helpForAlcoholAddiction == '0' && !this.healthForm.value.helpForAlcoholAddictionDescription) ||
      !this.healthForm.value.consumeCigarettes ||
      (this.healthForm.value.consumeCigarettes == '0' && !this.healthForm.value.consumeCigarettesDescription) ||
      !this.healthForm.value.seriousIllness ||
      (this.healthForm.value.seriousIllness == '0' && !this.healthForm.value.seriousIllnessDescription) ||
      !this.healthForm.value.dangerAtWork ||
      (this.healthForm.value.dangerAtWork == '0' && !this.healthForm.value.dangerAtWorkDescription) ||
      !this.healthForm.value.tenYearMedicalTests ||
      (this.healthForm.value.tenYearMedicalTests == '0' && !this.healthForm.value.tenYearmedicalTestsDescription) ||
      !this.healthForm.value.thirtyDaysIncapable ||
      (this.healthForm.value.thirtyDaysIncapable == '0' && !this.healthForm.value.thirtyDaysIncapableDescription) ||
      !this.healthForm.value.levelOfInvaliditet ||
      (this.healthForm.value.levelOfInvaliditet == '0' && !this.healthForm.value.levelOfInvaliditetDescription) ||
      !this.healthForm.value.newFifteenthQuestion ||
      (this.healthForm.value.newFifteenthQuestion == '0' && !this.healthForm.value.newFifteenthQuestionDescription) ||
      !this.healthForm.value.nameOfDoctor ||
      // (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && !this.healthForm.value.familySickness) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription)) ||
      !this.healthForm.value.agreeToHealthQuestionnaire
    ) {
      helthBool = true;
    } else {
      helthBool = false;
    }

    if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      if ((this.personalForm.value.planRadio == '2' || this.personalForm.value.planRadio == '3') && !this.healthForm.value.familySickness) {
        helthBool = true;
      }

    } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      if ((this.insuranceCoverageForm.value.planRadio == '2' || this.insuranceCoverageForm.value.planRadio == '3') && !this.healthForm.value.familySickness) {
        helthBool = true;
      }
    } else {
      if ((this.noCovrageForm.value.planRadio == '2' || this.noCovrageForm.value.planRadio == '3') && !this.healthForm.value.familySickness) {
        helthBool = true;
      }
    }

    if (
      (this.healthForm.value.consumeCigarettes == '0' && this.insuredSumAndPremiumForm.value.cigarettesDaily == 0) ||
      (this.healthForm.value.consumeCigarettes == '1' && this.insuredSumAndPremiumForm.value.cigarettesDaily > 0)
    ) {
      this.errorTitle = "Odgovor na ponudi u vezi cigareta nije usklađen sa upitnikom. Molimo ispravite odgovor na ponudi.";
      this.modalService.open(this.alertModal, { centered: true })
      return;
    }

    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.userSignature) {
        this.errorTitle = "Nemate potpis";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (
          ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
        ) {
          this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
          this.modalService.open(this.alertModal, { centered: true })
        } else {

          let mobileRegex = new RegExp('0[0-9]{7,9}')
          let postalCodeRegex = new RegExp('[0-9]{5}')
          if (this.basicInfo.data.contractorType == '1') {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
              this.digitalService.addInfo(true);
            } else {
              console.log(this.basicInfo.data.insuredMobile)
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                this.digitalService.addInfo(true);
              } else {
                if (this.insuredSumAndPremiumForm.value.currencyPayment == '' || this.insuredSumAndPremiumForm.value.currencyPayout == '' || this.insuredSumAndPremiumForm.value.indexation == '' || this.insuredSumAndPremiumForm.value.methodPayment == '') {
                  console.log(this.insuredSumAndPremiumForm.value.currencyPayment)
                  console.log(this.insuredSumAndPremiumForm.value.currencyPayout)
                  console.log(this.insuredSumAndPremiumForm.value.indexation)
                  console.log(this.insuredSumAndPremiumForm.value.methodPayment)
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber))
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
              console.log("Prosle basic")
              console.log(this.basicInfo)
              this.digitalService.addInfo(true);
            } else {
              console.log(this.basicInfo.data.insuredMobile)
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                console.log('prosole insured')
                this.digitalService.addInfo(true);
              } else {
                if (this.insuredSumAndPremiumForm.value.currencyPayment == '' || this.insuredSumAndPremiumForm.value.currencyPayout == '' || this.insuredSumAndPremiumForm.value.indexation == '' || this.insuredSumAndPremiumForm.value.methodPayment == '') {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  console.log(this.insuredSumAndPremiumForm.value.currencyPayment)
                  console.log(this.insuredSumAndPremiumForm.value.currencyPayout)
                  console.log(this.insuredSumAndPremiumForm.value.indexation)
                  console.log(this.insuredSumAndPremiumForm.value.methodPayment)
                  this.validInsuranceAndSumPremium = true;
                } else {
                  console.log("Prosle currency")
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    console.log("Prosli korisnici")
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      console.log("Prosao zdravstveni")
                      if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname ||
                          !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          console.log("Prosao spnft")
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              console.log("Prosao platiomatik")
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  signOnSpot(DBool) {
    // console.log(this.offerId);
    if (DBool) {
      this.offerService.createDigitalOffer(this.offerModelFull)
        .then(
          (x: any) => {
            console.log(x);
            this.offerId = x;
            this.offerService.createFromDraftOffer(this.offerId)
              .then(
                x => {
                  this.offerService.sendLocalDocuments(this.offerId)
                    .then(
                      x => {
                        this.modalService.dismissAll();
                        this.resetAllForms()
                        this.insuranceUsers = []
                        this.formPlatimatikBool = false;
                        this.formSpnftBool = false;
                        this.noticeFatcaBool = false;
                        this.healthQuestionnaireBool = false;
                        this.calculcatorUsersBool = false;
                        this.validInsuranceAndSumPremium = false;
                        this.validUser = false;
                        this.validSPNFT = false;
                        this.validPLATIMATIK = false;
                        this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                        // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
                      }
                    )
                },
                (x: any) => {
                  console.log(x)
                  this.errorTitle = x.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              )
          },
          (x: any) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.updateDraft(2);
    }
  }

  setTBRole() {
    let index = this.roles.findIndex(x => x.productRoleID == 3) // 3 za produkciju 8 za test
    if (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != null && this.personalForm.value.riderTB != 0 && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      if (index == -1) {
        this.roles.push({
          allowMultipleClients: false,
          maxClientsPerRole: 0,
          productRole: {
            createdBy: null,
            createdByID: 1,
            createdOn: "2020-06-08T12:54:32.007",
            id: 3, //3 za produkciju 8 za test
            lastModifiedBy: null,
            lastModifiedByID: null,
            lastModifiedOn: null,
            name: "U slučaju teže bolesti",
            productTypesRoles: []
          },
          productRoleID: 3, //3 za produkciju 8 za test
          productType: 2
        })
      }
    } else if (
      ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.personalForm.value.planRadio == '1') ||
      ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.insuranceCoverageForm.value.planRadio == '1') ||
      (this.supplementaryIsnuranceHideAllBool && this.noCovrageForm.value.planRadio == '1')
    ) {
      if (index != -1) {
        this.roles.splice(index, 1)
      }
    }
  }

  openSignOnDistanceModal(modal) {
    this.modalService.open(modal, { size: 'xl', backdrop: 'static', keyboard: false })
  }
  blockSendingBool: boolean = true
  openRiskModal(modal, DBool) {
    if (DBool) {
      this.blockSendingBool = false
      this.offerService.createDigitalOffer(this.offerModelFull)
        .then(
          (x: any) => {
            console.log(x);
            this.blockSendingBool = true
            this.offerId = x;
            this.riskAssessmentForm.reset();
            this.modalService.open(modal, { size: 'xl', backdrop: 'static', keyboard: false })
            if (this.spnftForm.value.officialCloseFamily == '1') {
              this.riskAssessmentForm.get('question11').setValue('0');
              this.riskAssessmentForm.get('question11').disable();
            } else {
              this.riskAssessmentForm.get('question11').enable();
            }
          },
          (x: any) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.updateDraft(1);
    }
  }
  addRiskAssessment() {
    if (this.riskAssessmentForm.valid) {
      let risk = new RiskAssessment({
        OfferID: this.offerId,
        Q1: this.riskAssessmentForm.value.question1 == '0' ? true : false,
        Q2: this.riskAssessmentForm.value.question2 == '0' ? true : false,
        Q3: this.riskAssessmentForm.value.question3 == '0' ? true : false,
        Q4: this.riskAssessmentForm.value.question4 == '0' ? true : false,
        Q5: this.riskAssessmentForm.value.question5 == '0' ? true : false,
        Q6: this.riskAssessmentForm.value.question6 == '0' ? true : false,
        Q7: this.riskAssessmentForm.value.question7 == '0' ? true : false,
        Q8: this.riskAssessmentForm.value.question8 == '0' ? true : false,
        Q9: this.riskAssessmentForm.value.question9 == '0' ? true : false,
        Q10: this.riskAssessmentForm.value.question10 == '0' ? true : false,
        Q11: this.riskAssessmentForm.get('question11').value == '0' ? true : false,
        Q12: this.riskAssessmentForm.value.question12 == '0' ? true : false,
        Q13: this.riskAssessmentForm.value.question13 == '0' ? true : false,
        Q14: this.riskAssessmentForm.value.question14 == '0' ? true : false,
        Q15: this.riskAssessmentForm.value.question15 == '0' ? true : false,
        Q16: this.riskAssessmentForm.value.question16 == '0' ? true : false,
        Q17: this.riskAssessmentForm.value.question17 == '0' ? true : false,
        Q18: this.riskAssessmentForm.value.question18 == '0' ? true : false,
        Q19: this.riskAssessmentForm.value.question19 == '0' ? true : false,
        Q20: this.riskAssessmentForm.value.question20 == '0' ? true : false,
        Q21: this.riskAssessmentForm.value.question21 == '0' ? true : false,
        Q22: this.riskAssessmentForm.value.question22 == '0' ? true : false,
        Q23: this.riskAssessmentForm.value.question23 == '0' ? true : false,
        Q24: this.riskAssessmentForm.value.question24 == '0' ? true : false,
        Q25: this.riskAssessmentForm.value.question25 == '0' ? true : false,
        Q26: this.riskAssessmentForm.value.question26 == '0' ? true : false,
        Q27: this.riskAssessmentForm.value.question27 == '0' ? true : false,
        Q28: this.riskAssessmentForm.value.question28 == '0' ? true : false,
        Q29: this.riskAssessmentForm.value.question29 == '0' ? true : false,
        UnableToGetData: false
      })
      this.offerService.createRiskAssessment(risk)
        .then(
          x => {
            // this.modalService.dismissAll();
            this.signDistance();
            // this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
          }
        )
    } else {
      // console.log("now checked wverything")
      this.errorTitle = "Niste odgovorili na sva pitanja";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }

  openSignOnSiteModal(modal) {
    this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
  }
  signDistance() {
    console.log(this.offerId);
    this.offerService.sentSignRequest(this.offerId)
      .then(
        x => {
          console.log(x);
          this.successTitle = "Uspešno ste kreirali digitalnu ponudu";
          this.modalService.dismissAll();
          this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
          this.resetAllForms()
          this.insuranceUsers = []
          this.formPlatimatikBool = false;
          this.formSpnftBool = false;
          this.noticeFatcaBool = false;
          this.healthQuestionnaireBool = false;
          this.calculcatorUsersBool = false;
          this.validInsuranceAndSumPremium = false;
          this.validUser = false;
          this.validSPNFT = false;
          this.validPLATIMATIK = false;
          this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
        }
      )
  }

  resetCalculation() {
    this.hideExport = false;
    if (this.insuredSumAndPremiumForm.value.cigarettesDaily > 0) {
      this.healthForm.get('consumeCigarettes').setValue('0')
      this.healthForm.get('consumeCigarettesDescription').setValue(this.insuredSumAndPremiumForm.value.cigarettesDaily.toString())
    } else {
      this.healthForm.get('consumeCigarettes').setValue('1')
      this.healthForm.get('consumeCigarettesDescription').setValue('')
    }
    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
      // if (this.basicInfo.data.insuredJMBG.length >= 12) {
      //   if (parseInt(this.basicInfo.data.insuredJMBG.substring(9, 12)) < 500) {
      //     if (this.insuredSumAndPremiumForm.value.gender == 'Ž') {
      //       this.insuredSumAndPremiumForm.get('gender').setValue('M')
      //     }
      //   } else {
      //     if (this.insuredSumAndPremiumForm.value.gender == 'M') {
      //       this.insuredSumAndPremiumForm.get('gender').setValue('Ž')
      //     }
      //   }
      // }
    }
  }

  insuredSumAndPremiumHide() {
    this.insuredSumANdPremimBool = !this.insuredSumANdPremimBool;
  }
  basicInsuranceHide() {
    this.basicInsuranceBool = !this.basicInsuranceBool;
  }
  supplementaryInsuranceHide() {
    this.supplementaryInsuranceBool = !this.supplementaryInsuranceBool;
    if (this.supplementaryInsuranceBool) {
      this.getRoles(Number(this.insuranceCoverageForm.value.planRadio) - 1);
    } else {
      this.getRoles(Number(this.personalForm.value.planRadio) - 1);
    }
  }
  healthQuestionnaireHide() {
    this.healthQuestionnaireBool = !this.healthQuestionnaireBool;
  }
  noticePersonalityHide() {
    this.noticePersonalityBool = !this.noticePersonalityBool;
  }
  noticeFatcaHide() {
    this.noticeFatcaBool = !this.noticeFatcaBool;
  }
  formSpnftHide() {
    this.formSpnftBool = !this.formSpnftBool;
  }
  formPlatimatikHide() {
    this.formPlatimatikBool = !this.formPlatimatikBool;
  }
  calculcatorUsersHide() {
    this.calculcatorUsersBool = !this.calculcatorUsersBool;
  }
  noSupplementaryHide() {
    if (this.basicInfoForm.value.noSupplementaryInsurance) {
      this.supplementaryIsnuranceHideAllBool = true;
    } else {
      this.supplementaryIsnuranceHideAllBool = false;
    }
    this.resetCalculation()
  }

  roles;
  getRoles(num) {
    // this.roles = this.productRoleService.getRoleByProduct(num)
    // console.log(num)
    this.productRoleService.getRoleByProduct(num)
      .subscribe(
        (res) => {
          this.roles = res;
          this.setTBRole()
          // console.log(this.roles)
        }
      )
  }
  // getOccupations(){
  //   this.arrayOccupation = this.
  // }

  get validInsuredSumAndPremiumForm() {
    return this.insuredSumAndPremiumForm.controls;
  }

  get validHealthForm() {
    return this.healthForm.controls;
  }

  setSPNFTDate() {
    if (this.spnftForm.value.jmbg.length >= 7) {
      if (this.spnftForm.value.jmbg.substring(4, 5) == '0') {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.2' + this.spnftForm.value.jmbg.substring(4, 7))
      } else {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.1' + this.spnftForm.value.jmbg.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dob').setValue('')
    }
  }

  setdobOnBehalf() {
    if (this.spnftForm.value.jmbgOnBehalf.length >= 7) {
      if (this.spnftForm.value.jmbgOnBehalf.substring(4, 5) == '0') {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.2' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      } else {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.1' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dobOnBehalf').setValue('')
    }
  }

  occupationArray;
  getOccupation() {
    this.occupationService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
      .subscribe(
        (x: { hazardLevel: Number, id: Number, name: String }[]) => {
          this.occupationArray = x;
        }
      )
  }

  userId;
  userSignature;
  getUser() {
    this.userService.getUser()
      .then(
        (x: { id: Number, signature: String }) => {
          this.userId = x.id;
          this.userSignature = x.signature;
          // console.log(x)
        }
      )
  }

  resetEverything() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', cigarettesDaily: '0' })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoForm.reset();
    this.healthForm.reset({ agreeToHealthQuestionnaire: true })
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.platimatikForm.reset()
    this.standardTableArray = []
    this.standardPlusTableArray = []
    this.standardProTableArray = []
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.insuranceCoverageForm.reset({ incidentRadio: '3', planRadio: '2' })
    this.personalForm.reset({ includeMSO: '0', includeDNA: '0', planRadio: '2', tbType: '' })
    this.noCovrageForm.reset({ planRadio: '2' })
    this.hideExport = false
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1', offer: true, redemptionAndCapitalization: false, proContract: false, terms: false, doctor: false })
    this.removeInfoService.sendOfferID(true);
    this.insuranceUsers = []
    this.validInsuranceAndSumPremium = false;
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.healthQuestionnaireBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    this.basicInfo = new BasicInformations({});
  }

}
